var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-button", on: { click: _vm.goToPriceGuardPage } },
    [
      _c(
        "v-tooltip",
        {
          attrs: { bottom: "" },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on }) {
                return [
                  _c("div", _vm._g({ staticClass: "home-button__icon" }, on), [
                    _c(
                      "svg",
                      {
                        staticStyle: {
                          "enable-background": "new 0 0 1080 1080",
                        },
                        attrs: {
                          id: "Layer_1",
                          xmlns: "http://www.w3.org/2000/svg",
                          "xmlns:xlink": "http://www.w3.org/1999/xlink",
                          x: "0px",
                          y: "0px",
                          height: "256px",
                          viewBox: "0 0 1080 1080",
                          "xml:space": "preserve",
                        },
                      },
                      [
                        _c("g", [
                          _c("path", {
                            staticClass: "st586",
                            attrs: {
                              d: "M784.4,365.8c6.7-29.5,10.1-61.9,10.1-96.2v-2.2c0-2-1.4-4.5-3.2-5.6c-1.8-1-3.2-0.2-3.2,1.8v2.2\n\t\tc0,33.7-3.3,65.6-9.9,94.6c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5C782.7,367.8,784.1,367.4,784.4,365.8z M768,231.4\n\t\tc1.1-0.9,0.9-3.4-0.4-5.5c-1.4-2.1-3.4-3.1-4.5-2.1c-5.2,4.2-8,11.6-8,20.8c0,40.8-5.2,106.2-16.7,153.6c-0.4,1.7,0.6,4.4,2.4,5.8\n\t\tc0.3,0.2,0.5,0.4,0.8,0.5c1.5,0.8,2.8,0.5,3.1-1c11.6-47.9,16.8-114.1,16.8-155.3C761.5,240.8,763.8,234.8,768,231.4z M818.2,281.1\n\t\tc0,2,1.4,4.5,3.2,5.6s3.2,0.2,3.2-1.8c0-22-15.6-49-34.8-60.1c-1.8-1-3.2-0.2-3.2,1.8c0,2,1.4,4.5,3.2,5.6\n\t\tC805.4,241.2,818.2,263.2,818.2,281.1z M818.8,324.8c-1.8-1.3-3.4-0.8-3.6,1.1c-4,34.6-11.7,79.3-19.7,113.8\n\t\tc-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.8,2.8,0.5,3.1-1c8-34.7,15.8-79.6,19.8-114.5\n\t\tC821.8,328.7,820.5,326.1,818.8,324.8z M809.6,276.1c0-12.5-8.9-27.8-19.7-34.1c-10.9-6.3-19.7-1.2-19.7,11.3\n\t\tc0,4.5-0.1,9.9-0.4,15.9c-0.1,2,1.3,4.5,3.1,5.7c1.8,1.1,3.3,0.4,3.4-1.6c0.3-6.2,0.4-11.6,0.4-16.3c0-8.4,6-11.8,13.3-7.6\n\t\ts13.3,14.5,13.3,22.9v2.2c0,33.1-11.7,110.4-22.1,157.3c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.9,2.8,0.5,3.1-1.1\n\t\tc10.5-47.3,22.2-125.3,22.2-158.9V276.1z M770.4,307.4c-1.8-1.2-3.4-0.6-3.5,1.3c-3.1,35.1-8.1,77-12.5,104.4\n\t\tc-0.3,1.8,0.9,4.4,2.7,5.8c0.2,0.1,0.4,0.3,0.5,0.4c1.5,0.9,2.9,0.4,3.2-1.3c4.4-27.5,9.5-69.6,12.6-104.8\n\t\tC773.5,311.2,772.2,308.7,770.4,307.4z M869.9,310.9c0-35.1-17.1-76.5-44.6-108c-1.6-1.8-3.5-2.2-4.3-0.8c-0.8,1.4-0.1,4,1.5,5.8\n\t\tc25.3,29,41,67.1,41,99.3v2.2c0,52.1-6.6,100.1-19.7,142.5c-0.5,1.7,0.5,4.3,2.2,5.9c0.3,0.3,0.6,0.5,0.9,0.7\n\t\tc1.4,0.8,2.7,0.5,3.1-0.9c13.2-43,19.9-91.6,19.9-144.4V310.9z M789.8,172.9c-44.1-25.5-80-5-80,45.6c0,2,1.4,4.5,3.2,5.6\n\t\tc1.8,1,3.2,0.2,3.2-1.8c0-46.6,33-65.4,73.6-42c1.8,1,3.2,0.2,3.2-1.8S791.6,173.9,789.8,172.9z M712.8,237.2\n\t\tc-1.8-1.1-3.3-0.4-3.3,1.6c-1.2,37.9-5.9,73.8-13.9,106.8c-0.4,1.7,0.6,4.4,2.4,5.9c0.3,0.2,0.5,0.4,0.8,0.6c1.5,0.8,2.8,0.5,3.1-1\n\t\tc8.1-33.4,12.8-69.8,14-108.2C716,240.8,714.6,238.3,712.8,237.2z M789.8,155.6c-52.5-30.3-95.1-6-95.1,54.2\n\t\tc0,41-4,79.7-11.9,115.1c-0.4,1.8,0.7,4.4,2.4,5.8c1.7,1.5,3.5,1.2,3.9-0.6c8-35.9,12-75.2,12-116.7c0-56.1,39.8-78.8,88.7-50.5\n\t\tc48.9,28.2,88.7,96.8,88.7,152.9v2.2c0,47.6-5.4,92-16,132c-0.5,1.7,0.6,4.3,2.3,5.9c0.3,0.2,0.6,0.4,0.8,0.6\n\t\tc1.4,0.8,2.7,0.5,3.1-1c10.8-40.5,16.2-85.6,16.2-133.8v-2.2C884.9,259.5,842.3,185.9,789.8,155.6z M839.7,293.5\n\t\tc0-31.6-22.4-70.2-49.9-86.1c-27.5-15.9-49.9-3.1-49.9,28.4c0,2,1.4,4.5,3.2,5.6c1.8,1,3.2,0.2,3.2-1.8c0-27.5,19.5-38.6,43.4-24.8\n\t\tc24,13.8,43.4,47.4,43.4,74.9v2.2c0,45.2-9.6,108.3-23.4,153.4c-0.5,1.7,0.5,4.3,2.2,5.9c0.3,0.3,0.6,0.5,0.9,0.7\n\t\tc1.4,0.8,2.7,0.5,3.1-0.9c14-45.7,23.7-109.6,23.7-155.4V293.5z M742.7,264.3c-1.8-1.2-3.3-0.4-3.4,1.6\n\t\tc-1.7,40.6-6.9,79.9-15.5,116.9c-0.4,1.8,0.7,4.4,2.4,5.8c0.2,0.2,0.5,0.4,0.7,0.5c1.5,0.8,2.8,0.5,3.1-1\n\t\tc8.7-37.4,13.9-77.1,15.7-118.1C745.8,268,744.4,265.5,742.7,264.3z M722.9,309.9c-1.8-1.3-3.4-0.9-3.7,1\n\t\tc-2.6,18.4-6.1,36.3-10.5,53.2c-0.4,1.7,0.6,4.3,2.3,5.9c0.3,0.2,0.5,0.4,0.8,0.6c1.4,0.8,2.8,0.5,3.1-1c4.4-17.2,8-35.3,10.6-53.9\n\t\tC725.8,313.8,724.6,311.3,722.9,309.9z M733.5,195c-5.7,8-8.7,19.1-8.7,32.2c0,23.2-1.2,46-3.6,67.6c-0.2,1.9,1.1,4.5,2.8,5.8\n\t\tc0.1,0.1,0.3,0.2,0.4,0.3c1.6,0.9,3,0.4,3.2-1.4c2.4-21.9,3.7-45,3.7-68.5c0-11.8,2.7-21.8,7.8-29c0.9-1.3,0.4-3.8-1.2-5.7\n\t\tC736.4,194.3,734.4,193.8,733.5,195z M751.6,182.4c-1.4,0.4-1.8,2.5-0.7,4.8c1,2.3,3.1,3.8,4.5,3.4c10-2.6,21.9-0.2,34.4,7\n\t\tc20.6,11.9,39.9,35.7,50.4,62.2c0.6,1.5,1.7,2.8,2.8,3.4c0.6,0.3,1.1,0.5,1.6,0.4c1.5-0.2,2-2.1,1.1-4.4\n\t\tc-11.7-29.4-33.1-55.9-56-69.1C776,182.2,762.8,179.5,751.6,182.4z M854.8,302.2c0-2-1.4-4.5-3.2-5.6c-1.8-1-3.2-0.2-3.2,1.8v2.2\n\t\tc0,53.6-7.2,102.5-21.4,145.4l-1.2,3.7c-0.5,1.6,0.4,4.3,2.1,5.9c0.3,0.3,0.7,0.6,1,0.7c1.4,0.8,2.6,0.5,3.1-0.8l1.2-3.7\n\t\tc14.4-43.5,21.7-93.1,21.7-147.4V302.2z",
                            },
                          }),
                          _c(
                            "g",
                            [
                              _c("path", {
                                staticClass: "st404",
                                attrs: {
                                  d: "M768.4,374.2c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l3.5,122\n\t\t\tc12.4,189.1,76.9,271.4,180.7,447.2l2.5,1.5c103.8-55.9,168.3-63.8,180.7-238.6l3.5-117.9L768.4,374.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st402",
                                attrs: {
                                  d: "M790.3,355.2c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5\n\t\t\tl-21.3,19.4l1.8,1.1c65.3,38.5,129.1,49.2,182.6,30.6l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9\n\t\t\tc-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9L790.3,355.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st402",
                                attrs: {
                                  d: "M792.8,356.6l-2.5-1.4c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4l-22,19l0.7,0.4\n\t\t\tc53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4L792.8,356.6z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st402",
                                attrs: {
                                  d: "M770.9,375.6l-3.5,117.9c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9\n\t\t\tL770.9,375.6z",
                                },
                              }),
                              _c(
                                "radialGradient",
                                {
                                  attrs: {
                                    id: "SVGID_00000035519460546054439730000003828010013045398689_",
                                    cx: "-840.9651",
                                    cy: "409.2891",
                                    r: "226.9041",
                                    gradientTransform:
                                      "matrix(0.9742 0 0 0.9742 1407.2067 12.4875)",
                                    gradientUnits: "userSpaceOnUse",
                                  },
                                },
                                [
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#FFFFFF" },
                                    attrs: { offset: "0" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#000000" },
                                    attrs: { offset: "1" },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticStyle: {
                                  fill: "url(#SVGID_00000035519460546054439730000003828010013045398689_)",
                                },
                                attrs: {
                                  d: "M770.9,372.4\n\t\t\tc-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l0.2,6.1c64.7,37.6,127.9,48,180.9,29.7\n\t\t\tl0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9c-6.4,90.9-27,136.7-59.9,167.5c35.2-30.9,57.2-76.6,63.9-171.2\n\t\t\tl3.5-117.9L770.9,372.4z",
                                },
                              }),
                              _c(
                                "g",
                                [
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000119830630719570513890000016175687552344491677_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1234.8898",
                                        y1: "519.6628",
                                        x2: "-570.2414",
                                        y2: "159.7008",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0",
                                      fill: "url(#SVGID_00000119830630719570513890000016175687552344491677_)",
                                    },
                                    attrs: {
                                      d: "M762.3,380.9\n\t\t\t\tc-64.1-36.3-126.8-98.2-179.3-177l-0.7-0.4c-52.5,18.2-115.2,7.7-179.3-30.1l-2.5-1.4l3.5,119.8\n\t\t\t\tc12.2,185.7,75.5,266.5,177.4,439.2l2.5,1.4c101.9-54.9,165.3-62.6,177.4-234.3l3.5-115.8L762.3,380.9z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000129170045387584533460000003735830957933658012_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1231.301",
                                        y1: "518.9431",
                                        x2: "-576.8375",
                                        y2: "164.4971",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "9.090909e-02",
                                      fill: "url(#SVGID_00000129170045387584533460000003735830957933658012_)",
                                    },
                                    attrs: {
                                      d: "M402.8,175.8\n\t\t\t\tc0.1,0,2.4,1.4,2.4,1.4c42.5,24.6,84.4,37.1,123.2,37.3c18.4,0.1,36.1-2.7,52.8-8.3c0,0,0.7,0.4,0.7,0.4\n\t\t\t\tc52.2,78,114.2,139.2,177.7,175.5c0.1,0,2.4,1.3,2.4,1.4c0.1,0.1,0.1,4.2,0.2,4.2L759,498c-11.9,168.3-73.1,177.1-172.8,230.6\n\t\t\t\tc-0.1,0-2.4-1.2-2.5-1.2c-3.5-4.9-6.9-9.6-10.3-14.3c-10.1-16.9-19.7-32.9-29-48.2c-78.5-130.2-127.1-211.9-138-370.4\n\t\t\t\tc-0.1-0.9-1.1-33.4-1.2-34.4L402.8,175.8z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000181062133632409417470000011774176061137814690_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1227.7107",
                                        y1: "518.23",
                                        x2: "-583.4238",
                                        y2: "169.2955",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.1818",
                                      fill: "url(#SVGID_00000181062133632409417470000011774176061137814690_)",
                                    },
                                    attrs: {
                                      d: "M405.2,179.6\n\t\t\t\tc0.1,0.1,2.3,1.3,2.4,1.3c41.7,23.6,82.8,35.7,120.9,35.8c18,0.1,35.4-2.6,51.8-8c0,0,0.7,0.3,0.7,0.3\n\t\t\t\tc51.8,77.1,113.1,137.7,176.1,174c0.1,0.1,2.3,1.3,2.4,1.4c0.2,0.1,0.3,3.9,0.5,4l-3.3,109.4c-11.7,165-70.6,174.9-168.2,227\n\t\t\t\tc-0.1,0.1-2.3-1-2.4-1c-3.6-4.1-7.2-8.2-10.8-12.1c-10-16.7-19.5-32.6-28.7-47.8c-78-129.4-126.4-210.6-137.6-366.7\n\t\t\t\tc-0.2-1.8-1.2-32.1-1.3-34.1L405.2,179.6z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000066489984332805978560000014543211730771902906_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1224.1189",
                                        y1: "517.5236",
                                        x2: "-589.9976",
                                        y2: "174.0946",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.2727",
                                      fill: "url(#SVGID_00000066489984332805978560000014543211730771902906_)",
                                    },
                                    attrs: {
                                      d: "M407.6,183.4\n\t\t\t\tc0.2,0.1,2.2,1.2,2.3,1.3c40.9,22.6,81.1,34.2,118.6,34.3c17.7,0.1,34.7-2.5,50.7-7.6c0.1,0,0.6,0.3,0.7,0.3\n\t\t\t\tc51.4,76.2,112.1,136.2,174.5,172.5c0.2,0.1,2.2,1.3,2.4,1.4c0.3,0.2,0.5,3.6,0.8,3.8l-3.2,108.4\n\t\t\t\tC743,659.4,686.2,670.4,590.9,721c-0.2,0.1-2.2-0.8-2.4-0.7c-3.8-3.4-7.6-6.7-11.3-9.9c-9.9-16.5-19.3-32.2-28.4-47.4\n\t\t\t\tC471.2,534.5,423,453.8,411.5,299.9c-0.3-2.7-1.3-30.8-1.5-33.8L407.6,183.4z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000019669498651515063450000016948023926545724565_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1220.5264",
                                        y1: "516.8241",
                                        x2: "-596.5543",
                                        y2: "178.8917",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.3636",
                                      fill: "url(#SVGID_00000019669498651515063450000016948023926545724565_)",
                                    },
                                    attrs: {
                                      d: "M410,187.2\n\t\t\t\tc0.2,0.1,2.1,1.1,2.3,1.2c40.1,21.7,79.5,32.7,116.3,32.8c17.3,0,33.9-2.4,49.7-7.2c0.1,0,0.6,0.2,0.7,0.2\n\t\t\t\tc51,75.3,111,134.6,172.9,171c0.3,0.2,2.1,1.2,2.3,1.4c0.4,0.3,0.7,3.3,1.2,3.6l-3.2,107.4C740.9,656,686.4,668,593.2,717.2\n\t\t\t\tc-0.3,0.1-2.1-0.6-2.4-0.5c-3.9-2.6-7.9-5.2-11.8-7.7c-9.8-16.4-19.1-31.9-28.2-46.9c-77-127.7-124.9-207.9-136.8-359.5\n\t\t\t\tc-0.4-3.7-1.3-29.5-1.6-33.5L410,187.2z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000156548615614106094480000000694834835964293054_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1216.9343",
                                        y1: "516.132",
                                        x2: "-603.0855",
                                        y2: "183.6823",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.4545",
                                      fill: "url(#SVGID_00000156548615614106094480000000694834835964293054_)",
                                    },
                                    attrs: {
                                      d: "M412.4,191\n\t\t\t\tc0.3,0.1,2,1.1,2.3,1.2c39.2,20.7,77.8,31.3,114,31.3c16.9,0,33.2-2.2,48.7-6.9c0.1,0,0.6,0.2,0.7,0.2\n\t\t\t\tc50.6,74.4,110,133.1,171.3,169.5c0.3,0.2,2,1.2,2.3,1.4c0.5,0.3,1,3.1,1.5,3.4l-3.2,106.4c-11,155-63.3,168.2-154.3,216\n\t\t\t\tc-0.3,0.2-2-0.4-2.4-0.3c-4.1-1.9-8.2-3.7-12.4-5.5c-9.7-16.2-18.9-31.6-27.9-46.5c-76.5-126.8-124.2-206.6-136.4-355.9\n\t\t\t\tc-0.5-4.6-1.4-28.2-1.8-33.1L412.4,191z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000045616482806559061670000006200995252694688438_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1213.345",
                                        y1: "515.4484",
                                        x2: "-609.5721",
                                        y2: "188.4556",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.5455",
                                      fill: "url(#SVGID_00000045616482806559061670000006200995252694688438_)",
                                    },
                                    attrs: {
                                      d: "M414.8,194.8\n\t\t\t\tc0.4,0.2,1.9,1,2.2,1.1c38.4,19.7,76.1,29.8,111.7,29.9c16.5,0,32.4-2.1,47.6-6.5c0.1,0,0.5,0.1,0.7,0.1\n\t\t\t\tc50.2,73.5,108.9,131.6,169.6,168c0.4,0.2,1.9,1.1,2.3,1.4c0.6,0.4,1.2,2.8,1.8,3.2l-3.1,105.4\n\t\t\t\tc-10.8,151.7-60.9,165.9-149.7,212.3c-0.4,0.2-1.9-0.2-2.4,0c-4.3-1.2-8.5-2.3-12.9-3.3c-9.6-16.1-18.8-31.3-27.6-46\n\t\t\t\tc-76-126-123.4-205.3-136-352.3c-0.6-5.5-1.5-26.9-1.9-32.8L414.8,194.8z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000140701174317916694100000004534448669191959708_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1209.8168",
                                        y1: "514.8044",
                                        x2: "-615.5168",
                                        y2: "192.942",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.6364",
                                      fill: "url(#SVGID_00000140701174317916694100000004534448669191959708_)",
                                    },
                                    attrs: {
                                      d: "M417.2,198.7\n\t\t\t\tc0.4,0.2,1.8,0.9,2.2,1.1c37.6,18.8,74.5,28.3,109.4,28.4c16.1,0,31.7-2,46.6-6.1c0.1,0,0.5,0.1,0.6,0.1\n\t\t\t\tc49.8,72.6,107.9,130.1,168,166.5c0.5,0.3,1.8,1.1,2.3,1.4c0.7,0.5,1.4,2.5,2.1,3l-3.1,104.4c-10.6,148.4-58.5,163.7-145,208.6\n\t\t\t\tc-0.5,0.2-1.9,0-2.3,0.2c-4.4-0.4-8.9-0.8-13.4-1c-9.5-15.9-18.6-31-27.4-45.6c-75.4-125.1-122.7-203.9-135.6-348.6\n\t\t\t\tc-0.7-6.4-1.6-25.6-2.1-32.5L417.2,198.7z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000006674412245030959520000006888649150597406397_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1206.2933",
                                        y1: "514.1691",
                                        x2: "-621.4032",
                                        y2: "197.4028",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.7273",
                                      fill: "url(#SVGID_00000006674412245030959520000006888649150597406397_)",
                                    },
                                    attrs: {
                                      d: "M419.6,202.5\n\t\t\t\tc0.5,0.2,1.7,0.8,2.2,1.1c36.7,17.8,72.8,26.8,107.1,26.9c15.7,0,31-1.9,45.5-5.8c0.1,0,0.5,0,0.6,0\n\t\t\t\tc49.5,71.7,106.8,128.6,166.4,165c0.5,0.3,1.7,1,2.2,1.4c0.8,0.5,1.6,2.2,2.5,2.7l-3.1,103.4c-10.4,145-56.1,161.5-140.4,205\n\t\t\t\tc-0.5,0.3-1.8,0.2-2.3,0.4c-4.6,0.3-9.2,0.7-13.9,1.2c-9.4-15.7-18.4-30.7-27.1-45.2c-74.9-124.3-121.9-202.6-135.2-345\n\t\t\t\tc-0.8-7.3-1.7-24.3-2.2-32.2L419.6,202.5z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000078741172361775021920000016305354809048701831_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1202.7688",
                                        y1: "513.5386",
                                        x2: "-627.2864",
                                        y2: "201.8675",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.8182",
                                      fill: "url(#SVGID_00000078741172361775021920000016305354809048701831_)",
                                    },
                                    attrs: {
                                      d: "M422,206.3\n\t\t\t\tc0.6,0.2,1.6,0.8,2.1,1c35.9,16.8,71.1,25.4,104.8,25.4c15.3,0,30.2-1.8,44.5-5.4c0.2,0,0.5,0,0.6,0\n\t\t\t\tc49.1,70.8,105.8,127,164.8,163.5c0.6,0.4,1.6,1,2.2,1.4c0.9,0.6,1.8,2,2.8,2.5L740.8,497C730.7,638.7,687.2,656.3,605,698.3\n\t\t\t\tc-0.6,0.3-1.7,0.4-2.3,0.7c-4.7,1.1-9.5,2.2-14.4,3.4c-9.3-15.6-18.2-30.3-26.9-44.7C487,534.3,440.3,456.4,426.6,316.3\n\t\t\t\tc-0.9-8.2-1.8-23-2.4-31.8L422,206.3z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000182490646042816118310000003247113031893043379_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1199.2433",
                                        y1: "512.9125",
                                        x2: "-633.1666",
                                        y2: "206.3354",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      opacity: "0.9091",
                                      fill: "url(#SVGID_00000182490646042816118310000003247113031893043379_)",
                                    },
                                    attrs: {
                                      d: "M424.4,210.1\n\t\t\t\tc0.6,0.3,1.5,0.7,2.1,1C461.5,226.9,496,235,529,235c14.9,0,29.5-1.7,43.4-5c0.2,0,0.4,0,0.6-0.1\n\t\t\t\tc48.7,69.9,104.7,125.5,163.2,162c0.7,0.4,1.5,0.9,2.2,1.4c1,0.6,2.1,1.7,3.1,2.3l-3,101.4c-9.9,138.4-51.2,157-131.2,197.6\n\t\t\t\tc-0.7,0.3-1.6,0.6-2.3,0.9c-4.9,1.8-9.8,3.7-14.9,5.6c-9.2-15.4-18-30-26.6-44.3C489.7,534.2,443.1,456.9,429.1,319\n\t\t\t\tc-1-9.1-1.9-21.7-2.5-31.5L424.4,210.1z",
                                    },
                                  }),
                                  _c(
                                    "linearGradient",
                                    {
                                      attrs: {
                                        id: "SVGID_00000134936805157642595510000015344770716848911265_",
                                        gradientUnits: "userSpaceOnUse",
                                        x1: "-1195.7172",
                                        y1: "512.2904",
                                        x2: "-639.0441",
                                        y2: "210.806",
                                        gradientTransform:
                                          "matrix(1 0 0 1 1603.9998 0)",
                                      },
                                    },
                                    [
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#C3A8D0",
                                        },
                                        attrs: { offset: "0.404" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#CEB8D9",
                                        },
                                        attrs: { offset: "0.5457" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#EAE1EF",
                                        },
                                        attrs: { offset: "0.8201" },
                                      }),
                                      _c("stop", {
                                        staticStyle: {
                                          "stop-color": "#FFFFFF",
                                        },
                                        attrs: { offset: "1" },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c("path", {
                                    staticStyle: {
                                      fill: "url(#SVGID_00000134936805157642595510000015344770716848911265_)",
                                    },
                                    attrs: {
                                      d: "M592,699.7\n\t\t\t\tc-9.1-15.2-17.8-29.7-26.3-43.8C486.9,525.1,439.3,446.2,429,290.6l-2.2-76.6c34.9,15.5,69.2,23.3,102.3,23.3\n\t\t\t\tc14.8,0,29.2-1.6,43-4.8c49.9,71.3,107.2,127.5,167.1,164l-3,100.4c-9.7,135-48.8,154.8-126.5,194\n\t\t\t\tC603.9,693.7,598.1,696.7,592,699.7z",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticClass: "st409",
                                attrs: {
                                  d: "M748.6,393c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5\n\t\t\tl-21.3,19.4l1.8,1.1c65.3,38.5,129.1,49.2,182.6,30.6l0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9\n\t\t\tc-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9L748.6,393z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st402",
                                attrs: {
                                  d: "M751.1,394.4l-2.5-1.4c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4l-22,19l0.7,0.4\n\t\t\tc53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4L751.1,394.4z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st402",
                                attrs: {
                                  d: "M729.1,413.5l-3.5,117.9c-8.1,114.1-38.4,157-87.3,188.7c61.1-36.1,100.2-79.5,109.3-207.7l3.5-117.9\n\t\t\tL729.1,413.5z",
                                },
                              }),
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "SVGID_00000134217653593046735010000007812563709478468264_",
                                    gradientUnits: "userSpaceOnUse",
                                    x1: "629.2128",
                                    y1: "291.2595",
                                    x2: "395.4393",
                                    y2: "646.894",
                                  },
                                },
                                [
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#166250" },
                                    attrs: { offset: "0" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#196955" },
                                    attrs: { offset: "0.1797" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#237B64" },
                                    attrs: { offset: "0.4323" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#32997C" },
                                    attrs: { offset: "0.7265" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#44BB98" },
                                    attrs: { offset: "1" },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticStyle: {
                                  opacity: "0.7",
                                  fill: "url(#SVGID_00000134217653593046735010000007812563709478468264_)",
                                },
                                attrs: {
                                  d: "M530.7,688.5\n\t\t\tc-80.6-133.7-121.1-200.9-130.9-347.6l-2.2-77c51.7,23.4,101.3,30.9,146,22c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4\n\t\t\tc-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5C539.3,702.6,535,695.5,530.7,688.5z",
                                },
                              }),
                              _c(
                                "linearGradient",
                                {
                                  attrs: {
                                    id: "SVGID_00000098210681526701133460000012973131674500435847_",
                                    gradientUnits: "userSpaceOnUse",
                                    x1: "441.328",
                                    y1: "497.8589",
                                    x2: "744.7236",
                                    y2: "497.8589",
                                  },
                                },
                                [
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#166250" },
                                    attrs: { offset: "0" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#196955" },
                                    attrs: { offset: "0.1797" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#237B64" },
                                    attrs: { offset: "0.4323" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#32997C" },
                                    attrs: { offset: "0.7265" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#44BB98" },
                                    attrs: { offset: "1" },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticStyle: {
                                  opacity: "0.1",
                                  fill: "url(#SVGID_00000098210681526701133460000012973131674500435847_)",
                                },
                                attrs: {
                                  d: "M543.7,285.8\n\t\t\tc44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5V285.8z",
                                },
                              }),
                              _c(
                                "radialGradient",
                                {
                                  attrs: {
                                    id: "SVGID_00000139252571065866727240000001287576153138664585_",
                                    cx: "-883.7821",
                                    cy: "448.1624",
                                    r: "226.9041",
                                    gradientTransform:
                                      "matrix(0.9742 0 0 0.9742 1407.2067 12.4875)",
                                    gradientUnits: "userSpaceOnUse",
                                  },
                                },
                                [
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#FFFFFF" },
                                    attrs: { offset: "0" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#000000" },
                                    attrs: { offset: "1" },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticStyle: {
                                  fill: "url(#SVGID_00000139252571065866727240000001287576153138664585_)",
                                },
                                attrs: {
                                  d: "M729.2,410.2\n\t\t\tc-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l0.2,6.1c64.7,37.6,127.9,48,180.9,29.7\n\t\t\tl0.7,0.4c53.5,80.3,117.3,143.3,182.6,180.2l2.5,1.4l-3.5,117.9c-6.4,90.9-27,136.7-59.9,167.5c35.2-30.9,57.2-76.6,63.9-171.2\n\t\t\tl3.5-117.9L729.2,410.2z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st603",
                                attrs: {
                                  d: "M530.7,688.5c-80.6-133.7-121.1-200.9-130.9-347.6l-2.2-77c51.7,23.4,101.3,30.9,146,22\n\t\t\tc44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5\n\t\t\tC539.3,702.6,535,695.5,530.7,688.5z",
                                },
                              }),
                              _c("path", {
                                staticClass: "st404",
                                attrs: {
                                  d: "M726.6,412.1c-65.3-36.9-129.1-100-182.6-180.2l-0.7-0.4c-53.5,18.5-117.3,7.8-182.6-30.6l-2.5-1.5l3.5,122\n\t\t\tc12.4,189.1,76.9,271.4,180.7,447.2l2.5,1.5c103.8-55.9,168.3-63.8,180.7-238.6l3.5-117.9L726.6,412.1z M687.5,506.9\n\t\t\tc-9.8,135.4-50.3,155.9-130.9,196.5c-4.2,2.1-8.5,4.3-12.9,6.5c-4.4-7.3-8.7-14.4-12.9-21.4c-80.6-133.7-121.1-200.9-130.9-347.6\n\t\t\tl-2.2-77c51.7,23.4,101.3,30.9,146,22c44.7,60.5,94.3,110.3,146,146.7L687.5,506.9z",
                                },
                              }),
                              _c(
                                "radialGradient",
                                {
                                  attrs: {
                                    id: "SVGID_00000112612924435005604920000014917156105305870728_",
                                    cx: "-886.4156",
                                    cy: "457.7703",
                                    r: "176.6032",
                                    gradientTransform:
                                      "matrix(0.9742 0 0 0.9742 1407.2067 12.4875)",
                                    gradientUnits: "userSpaceOnUse",
                                  },
                                },
                                [
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#FFFFFF" },
                                    attrs: { offset: "0" },
                                  }),
                                  _c("stop", {
                                    staticStyle: { "stop-color": "#000000" },
                                    attrs: { offset: "1" },
                                  }),
                                ],
                                1
                              ),
                              _c("path", {
                                staticStyle: {
                                  fill: "url(#SVGID_00000112612924435005604920000014917156105305870728_)",
                                },
                                attrs: {
                                  d: "M543.7,285.8c-44.7,8.9-94.3,1.4-146-22\n\t\t\tl0.1,4.7c50.5,22.2,98.9,29.2,142.6,20.5c44.7,60.5,94.3,110.3,146,146.7l-2.2,74.4c-5.5,75.7-20.5,115.4-46.8,142.9\n\t\t\tc28.3-27.6,44.4-67.4,50.1-146.2l2.2-74.4C637.9,396.1,588.3,346.3,543.7,285.8z",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("g", [
                            _c("g", { staticClass: "st401" }, [
                              _c("g", [
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st605",
                                    attrs: {
                                      d: "M205.1,611.2l42.2-24.4c3.4-2,8.9-2,12.3,0l128.6,74.7c3.4,2,3.3,5.2,0,7.1L346,693.1\n\t\t\t\t\t\tc-3.4,2-8.9,2-12.3,0l-128.6-74.7C201.7,616.4,201.7,613.2,205.1,611.2L205.1,611.2z",
                                    },
                                  }),
                                ]),
                              ]),
                            ]),
                            _c("g", [
                              _c("g", [
                                _c("g", { staticClass: "st417" }, [
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st402",
                                      attrs: {
                                        d: "M197.5,482.8l40.8-23.7c1.3-0.8,3.1-0.7,5.1,0.5l-40.8,23.7C200.6,482.1,198.8,482,197.5,482.8z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st409",
                                      attrs: {
                                        d: "M372.6,665.6l-40.8,23.7c1.3-0.7,2.1-2.3,2.1-4.6l40.8-23.7C374.7,663.3,373.9,664.9,372.6,665.6z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("polygon", {
                                      staticClass: "st409",
                                      attrs: {
                                        points:
                                          "334.2,567.5 375,543.8 374.7,661.1 333.9,684.7 \t\t\t\t\t\t",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("polygon", {
                                      staticClass: "st402",
                                      attrs: {
                                        points:
                                          "202.5,483.3 243.3,459.6 367.9,531.5 327.1,555.2 \t\t\t\t\t\t",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st402",
                                      attrs: {
                                        d: "M327.1,555.2l40.8-23.7c3.9,2.3,7.1,7.8,7.1,12.3l-40.8,23.7C334.3,563,331.1,557.5,327.1,555.2z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st404",
                                      attrs: {
                                        d: "M327.1,555.2c3.9,2.3,7.1,7.8,7.1,12.3l-0.3,117.2c0,4.5-3.2,6.3-7.1,4.1l-124.6-71.9\n\t\t\t\t\t\t\tc-3.9-2.3-7.1-7.8-7.1-12.3l0.3-117.2c0-4.5,3.2-6.3,7.1-4.1L327.1,555.2z",
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("g", [
                                _c("g", { staticClass: "st417" }, [
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st405",
                                      attrs: {
                                        d: "M258.2,553.2c-8.1-4.7-14.7-0.9-14.7,8.4c0,5.9,2.6,12.6,6.6,17.9l1.1-6.6c0.3-1.6,1.6-2.1,3.1-1.2\n\t\t\t\t\t\t\tl7.8,4.5c1.6,0.9,2.9,2.9,3.1,4.9l1,7.8c4-0.7,6.6-4.4,6.6-10.3C272.8,569.3,266.3,557.9,258.2,553.2L258.2,553.2z",
                                      },
                                    }),
                                    _c("path", {
                                      staticClass: "st405",
                                      attrs: {
                                        d: "M262,576.2l-7.8-4.5c-1.6-0.9-2.9-0.4-3.1,1.2l-1.1,6.6l-3.5,21.9c-0.3,2,1.2,4.9,3.1,6l16.8,9.7\n\t\t\t\t\t\t\tc2,1.1,3.4,0,3.1-2.4l-3.4-25.8l-1-7.8C264.9,579.2,263.6,577.1,262,576.2L262,576.2z",
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                              _c("g", [
                                _c("g", { staticClass: "st417" }, [
                                  _c("g", [
                                    _c("polygon", {
                                      staticClass: "st606",
                                      attrs: {
                                        points:
                                          "245.3,474.4 257.5,467.3 257.5,483.4 245.3,490.5 \t\t\t\t\t\t",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st606",
                                      attrs: {
                                        d: "M256.5,449.9l12.2-7.1c-6.9,4-11.1,12.5-11.2,24.5l-12.2,7.1C245.3,462.3,249.6,453.9,256.5,449.9z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("polygon", {
                                      staticClass: "st607",
                                      attrs: {
                                        points:
                                          "333.6,525.3 345.8,518.2 345.7,534.3 333.5,541.4 \t\t\t\t\t\t",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st607",
                                      attrs: {
                                        d: "M248.4,435.5l12.2-7.1c9.5-5.4,22.1-4.2,35.4,3.5l-12.2,7.1C270.4,431.4,257.9,430.1,248.4,435.5z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st607",
                                      attrs: {
                                        d: "M283.7,439l12.2-7.1c13.3,7.7,25.8,20.9,35.2,37.2c9.4,16.3,14.6,33.8,14.6,49l-12.2,7.1\n\t\t\t\t\t\t\tc0-15.3-5.1-32.7-14.6-49C309.6,459.9,297,446.7,283.7,439z",
                                      },
                                    }),
                                  ]),
                                  _c("g", [
                                    _c("path", {
                                      staticClass: "st405",
                                      attrs: {
                                        d: "M283.7,439c13.3,7.7,25.8,20.9,35.2,37.2c9.4,16.3,14.6,33.8,14.6,49l0,16.1l-11.7-6.8l0-16.1\n\t\t\t\t\t\t\tc0.1-24.2-17-53.9-38.1-66.1c-21.1-12.2-38.3-2.4-38.4,21.9l0,16.1l-11.7-6.8l0-16.1c0-15.3,5.3-26.7,14.8-32.1\n\t\t\t\t\t\t\tC257.9,430.1,270.4,431.4,283.7,439z",
                                      },
                                    }),
                                  ]),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c("g", [
                            _c("g", [
                              _c("g", { staticClass: "st417" }, [
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st608",
                                    attrs: {
                                      points:
                                        "474.3,463 479.6,461.3 479.8,461.3 474.5,463.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000021091012669550497980000002442216190549425077_",
                                        d: "M472.1,449l5.3-1.8\n\t\t\t\t\t\t\tc-1.8,0.6-3,2.5-3.1,5.2c-0.1,3.9,2.2,7.8,5.3,8.8l-5.3,1.8c-3-1-5.4-4.9-5.3-8.8C469.1,451.6,470.4,449.6,472.1,449z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000047745049773000807560000004615766510637104013_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000021091012669550497980000002442216190549425077_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000047745049773000807560000004615766510637104013_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M472.1,449l5.3-1.8c-0.7,0.2-1.3,0.6-1.8,1.2l-5.3,1.8C470.9,449.7,471.5,449.2,472.1,449",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st460",
                                        attrs: {
                                          d: "M470.4,450.2l5.3-1.8c-0.1,0.1-0.2,0.3-0.3,0.4l-5.3,1.8C470.2,450.5,470.3,450.4,470.4,450.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st461",
                                        attrs: {
                                          d: "M470.1,450.7l5.3-1.8c-0.1,0.1-0.1,0.2-0.2,0.3l-5.3,1.8C469.9,450.9,470,450.8,470.1,450.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M469.9,451l5.3-1.8c-0.1,0.1-0.1,0.2-0.2,0.3l-5.3,1.8C469.7,451.2,469.8,451.1,469.9,451",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M469.7,451.3l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.6,451.5,469.6,451.4,469.7,451.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M469.6,451.6l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.5,451.8,469.5,451.7,469.6,451.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M469.4,451.9l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.4,452.1,469.4,452,469.4,451.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M469.3,452.2l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C469.3,452.4,469.3,452.3,469.3,452.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M469.3,452.5l5.3-1.8c0,0.1,0,0.2-0.1,0.3l-5.3,1.8C469.2,452.7,469.2,452.6,469.3,452.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M469.2,452.8l5.3-1.8c0,0.1,0,0.2-0.1,0.3l-5.3,1.8C469.2,453,469.2,452.9,469.2,452.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M469.1,453.1l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469.1,453.3,469.1,453.2,469.1,453.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M469.1,453.3l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469.1,453.5,469.1,453.4,469.1,453.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M469.1,453.6l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,453.8,469.1,453.7,469.1,453.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st615",
                                        attrs: {
                                          d: "M469,453.9l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.1,469,454,469,453.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st616",
                                        attrs: {
                                          d: "M469,454.2l5.3-1.8c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.5,469,454.4,469,454.2\n\t\t\t\t\t\t\tC469,454.3,469,454.3,469,454.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st617",
                                        attrs: {
                                          d: "M469,454.6l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,454.8,469,454.7,469,454.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st618",
                                        attrs: {
                                          d: "M469,454.9l5.3-1.8c0,0.1,0,0.2,0,0.3l-5.3,1.8C469,455.1,469,455,469,454.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st619",
                                        attrs: {
                                          d: "M469,455.2l5.3-1.8c0,0.1,0,0.2,0,0.4l-5.3,1.8C469.1,455.5,469.1,455.3,469,455.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st620",
                                        attrs: {
                                          d: "M469.1,455.6l5.3-1.8c0,0.1,0,0.2,0,0.4l-5.3,1.8C469.1,455.8,469.1,455.7,469.1,455.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st621",
                                        attrs: {
                                          d: "M469.1,455.9l5.3-1.8c0,0.1,0,0.3,0.1,0.4l-5.3,1.8C469.2,456.2,469.1,456.1,469.1,455.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st622",
                                        attrs: {
                                          d: "M469.2,456.3l5.3-1.8c0,0.1,0.1,0.3,0.1,0.4l-5.3,1.8C469.3,456.6,469.2,456.5,469.2,456.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st623",
                                        attrs: {
                                          d: "M469.3,456.8l5.3-1.8c0,0.2,0.1,0.3,0.1,0.5l-5.3,1.8C469.4,457.1,469.3,457,469.3,456.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st624",
                                        attrs: {
                                          d: "M469.4,457.3l5.3-1.8c0.1,0.2,0.1,0.4,0.2,0.7l-5.3,1.8C469.6,457.7,469.5,457.5,469.4,457.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st625",
                                        attrs: {
                                          d: "M469.6,457.9l5.3-1.8c0.3,0.7,0.6,1.4,1,2l-5.3,1.8C470.2,459.3,469.9,458.7,469.6,457.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st624",
                                        attrs: {
                                          d: "M470.6,459.9l5.3-1.8c0.1,0.2,0.3,0.4,0.4,0.6l-5.3,1.8C470.9,460.3,470.7,460.1,470.6,459.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st623",
                                        attrs: {
                                          d: "M471,460.5l5.3-1.8c0.1,0.1,0.2,0.3,0.3,0.4l-5.3,1.8C471.2,460.8,471.1,460.7,471,460.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st622",
                                        attrs: {
                                          d: "M471.4,461l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3l-5.3,1.8C471.6,461.2,471.5,461.1,471.4,461",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st621",
                                        attrs: {
                                          d: "M471.7,461.3l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3l-5.3,1.8C471.8,461.5,471.7,461.4,471.7,461.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st620",
                                        attrs: {
                                          d: "M471.9,461.6l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.2l-5.3,1.8C472.1,461.7,472,461.7,471.9,461.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st619",
                                        attrs: {
                                          d: "M472.2,461.8l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.4,462,472.3,461.9,472.2,461.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st618",
                                        attrs: {
                                          d: "M472.4,462l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.6,462.1,472.5,462.1,472.4,462",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st617",
                                        attrs: {
                                          d: "M472.7,462.2l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.2l-5.3,1.8C472.8,462.3,472.8,462.3,472.7,462.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st616",
                                        attrs: {
                                          d: "M472.9,462.4l5.3-1.8c0.1,0.1,0.2,0.1,0.2,0.1l-5.3,1.8C473.1,462.5,473,462.4,472.9,462.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st615",
                                        attrs: {
                                          d: "M473.2,462.5l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.3,462.6,473.2,462.6,473.2,462.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M473.4,462.7l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.5,462.7,473.5,462.7,473.4,462.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M473.6,462.8l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C473.8,462.8,473.7,462.8,473.6,462.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M473.9,462.9l5.3-1.8c0.1,0,0.2,0.1,0.2,0.1l-5.3,1.8C474,462.9,473.9,462.9,473.9,462.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M474.1,463l5.3-1.8c0.1,0,0.1,0,0.2,0.1l-5.3,1.8C474.2,463,474.2,463,474.1,463",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000086660132027587354870000008980238082251648932_",
                                        d: "M488.5,461.4l-5.3,1.8\n\t\t\t\t\t\t\tc-2.6,0.9-5.6,0.9-8.7-0.1l5.3-1.8C482.9,462.3,485.9,462.3,488.5,461.4z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000019656100368551129390000005734460661595885740_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000086660132027587354870000008980238082251648932_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000019656100368551129390000005734460661595885740_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M474.5,463.1l5.3-1.8c0,0,0,0,0,0L474.5,463.1C474.5,463.1,474.5,463.1,474.5,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M474.5,463.1l5.3-1.8c0.3,0.1,0.6,0.2,0.9,0.2l-5.3,1.8C475.1,463.3,474.8,463.2,474.5,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M475.4,463.4l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C476,463.5,475.7,463.4,475.4,463.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M476.3,463.6l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C476.9,463.7,476.6,463.6,476.3,463.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M477.2,463.7l5.3-1.8c0.3,0,0.6,0.1,1,0.1l-5.3,1.8C477.8,463.8,477.5,463.8,477.2,463.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M478.2,463.8l5.3-1.8c0.3,0,0.7,0,1,0l-5.3,1.8C478.8,463.8,478.5,463.8,478.2,463.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M479.2,463.8l5.3-1.8c0.4,0,0.7,0,1.1,0l-5.3,1.8C479.9,463.8,479.5,463.8,479.2,463.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st461",
                                        attrs: {
                                          d: "M480.2,463.8l5.3-1.8c0.4,0,0.8-0.1,1.3-0.2l-5.3,1.8C481.1,463.7,480.7,463.8,480.2,463.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st460",
                                        attrs: {
                                          d: "M481.5,463.6l5.3-1.8c0.5-0.1,1-0.2,1.5-0.4l-5.3,1.8C482.5,463.4,482,463.5,481.5,463.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M483,463.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C483.1,463.2,483.1,463.2,483,463.2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000114051439071818773620000012608572968290134969_",
                                        d: "M482.2,461.3l-5.3,1.8\n\t\t\t\t\t\t\tc-0.8,0.3-1.6,0.3-2.5,0l5.3-1.8C480.5,461.6,481.4,461.6,482.2,461.3z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000154400431527281858590000008640803491004312218_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000114051439071818773620000012608572968290134969_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000154400431527281858590000008640803491004312218_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M474.4,463.1l5.3-1.8c0,0,0,0,0,0L474.4,463.1C474.4,463.1,474.4,463.1,474.4,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M474.4,463.1l5.3-1.8c0.1,0,0.2,0,0.2,0.1l-5.3,1.8C474.6,463.1,474.5,463.1,474.4,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M474.7,463.1l5.3-1.8c0.1,0,0.2,0,0.3,0.1l-5.3,1.8C474.8,463.2,474.7,463.2,474.7,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M474.9,463.2l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.1,463.2,475,463.2,474.9,463.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M475.2,463.2l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.4,463.3,475.3,463.3,475.2,463.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M475.4,463.3l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.6,463.3,475.5,463.3,475.4,463.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M475.7,463.3l5.3-1.8c0.1,0,0.2,0,0.3,0l-5.3,1.8C475.9,463.3,475.8,463.3,475.7,463.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st461",
                                        attrs: {
                                          d: "M476,463.3l5.3-1.8c0.1,0,0.2,0,0.4,0l-5.3,1.8C476.3,463.2,476.2,463.3,476,463.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st460",
                                        attrs: {
                                          d: "M476.4,463.2l5.3-1.8c0.2,0,0.3-0.1,0.4-0.1l-5.3,1.8C476.7,463.1,476.6,463.2,476.4,463.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M476.9,463.1l5.3-1.8c0,0,0,0,0,0L476.9,463.1C476.9,463.1,476.9,463.1,476.9,463.1",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000152233772595064132700000003764262048990774425_",
                                        d: "M455.9,431.8l5.3-1.8\n\t\t\t\t\t\t\tc3-0.2,9.3-0.8,14.3-0.4l-5.3,1.8C465.2,431,458.9,431.5,455.9,431.8z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000063634383345063811370000006635483819495527855_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000152233772595064132700000003764262048990774425_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000063634383345063811370000006635483819495527855_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M455.9,431.8l5.3-1.8c2.3-0.2,6.5-0.5,10.5-0.5l-5.3,1.8C462.4,431.2,458.2,431.6,455.9,431.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M466.4,431.2l5.3-1.8c1.3,0,2.6,0,3.8,0.1l-5.3,1.8C469,431.2,467.7,431.2,466.4,431.2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000096061034555108869080000002813535797489323178_",
                                        d: "M470.2,431.3l5.3-1.8\n\t\t\t\t\t\t\tc1.6,0,3.2,0.2,4.9,0.8l-5.3,1.8C473.5,431.5,471.8,431.3,470.2,431.3z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000101069934846068598600000010441756820184986526_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000096061034555108869080000002813535797489323178_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000101069934846068598600000010441756820184986526_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M470.2,431.3l5.3-1.8c0.1,0,0.2,0,0.2,0l-5.3,1.8C470.4,431.3,470.3,431.3,470.2,431.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M470.5,431.3l5.3-1.8c0.3,0,0.7,0,1,0l-5.3,1.8C471.1,431.3,470.8,431.3,470.5,431.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M471.5,431.3l5.3-1.8c0.3,0,0.6,0.1,0.9,0.1l-5.3,1.8C472.1,431.4,471.8,431.4,471.5,431.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M472.4,431.4l5.3-1.8c0.3,0,0.6,0.1,0.9,0.1l-5.3,1.8C473,431.5,472.7,431.5,472.4,431.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M473.3,431.6l5.3-1.8c0.3,0.1,0.6,0.1,0.9,0.2l-5.3,1.8C473.9,431.7,473.6,431.6,473.3,431.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M474.2,431.8l5.3-1.8c0.3,0.1,0.6,0.2,0.9,0.2L475,432C474.7,431.9,474.5,431.9,474.2,431.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M475,432l5.3-1.8c0.1,0,0.1,0,0.2,0.1l-5.3,1.8C475.1,432.1,475.1,432,475,432",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st630",
                                    attrs: {
                                      points:
                                        "477.6,433.1 482.9,431.3 482.4,448.8 477.1,450.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000149361727746133923360000012826819687795099792_",
                                        d: "M475.2,432.1l5.3-1.8\n\t\t\t\t\t\t\tc0.8,0.3,1.6,0.6,2.4,1l-5.3,1.8C476.8,432.7,476,432.3,475.2,432.1z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000113314299025296647640000013082143265746429860_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000149361727746133923360000012826819687795099792_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000113314299025296647640000013082143265746429860_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M475.2,432.1l5.3-1.8c0.2,0.1,0.4,0.1,0.7,0.2l-5.3,1.8C475.6,432.2,475.4,432.1,475.2,432.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M475.8,432.3l5.3-1.8c0.3,0.1,0.5,0.2,0.8,0.3l-5.3,1.8C476.4,432.5,476.1,432.4,475.8,432.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M476.7,432.6l5.3-1.8c0.3,0.1,0.5,0.2,0.8,0.4l-5.3,1.8C477.2,432.9,476.9,432.8,476.7,432.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M477.5,433l5.3-1.8c0,0,0.1,0,0.1,0L477.5,433C477.5,433,477.5,433,477.5,433",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000109744442028154281880000009257130239630960793_",
                                        d: "M492.8,459c-1.3,1.1-2.7,1.9-4.3,2.4\n\t\t\t\t\t\t\tl-5.3,1.8c1.6-0.5,3-1.4,4.3-2.5C489.3,460.2,491,459.5,492.8,459z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000149380875278490882170000011778429085620809354_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000109744442028154281880000009257130239630960793_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000149380875278490882170000011778429085620809354_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000047762229156646663830000018435665673527025066_",
                                        d: "M492.8,459c-1.8,0.6-3.5,1.2-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.4-0.1,0.6-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.2,0.7-0.2c0.2-0.1,0.5-0.2,0.7-0.2C492.3,459.1,492.6,459,492.8,459z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000178175449698002588860000018001381002577934003_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000047762229156646663830000018435665673527025066_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000178175449698002588860000018001381002577934003_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000135682722256356029830000007401042989813471398_",
                                        d: "M479.7,485.8l-5.3,1.8\n\t\t\t\t\t\t\tc3.2-1.1,14.3-5.1,16.9-9.7c0.4-0.8,0.8-2.6,1.1-4.9l5.3-1.8c-0.3,2.4-0.7,4.2-1.1,4.9C494,480.7,482.9,484.7,479.7,485.8z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000145738029119061177970000000703833195619669688_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000135682722256356029830000007401042989813471398_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000145738029119061177970000000703833195619669688_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M492.4,472.9l5.3-1.8c0,0.2-0.1,0.5-0.1,0.7l-5.3,1.8C492.4,473.4,492.4,473.1,492.4,472.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M492.4,473.6l5.3-1.8c-0.1,0.5-0.1,1-0.2,1.4l-5.3,1.8C492.2,474.6,492.3,474.1,492.4,473.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M492.1,475l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C492,475.6,492.1,475.3,492.1,475",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M492,475.9l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C491.9,476.3,491.9,476.1,492,475.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M491.8,476.5l5.3-1.8c0,0.2-0.1,0.3-0.1,0.4l-5.3,1.8C491.7,476.8,491.8,476.7,491.8,476.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M491.7,477l5.3-1.8c0,0.1-0.1,0.2-0.1,0.3l-5.3,1.8C491.6,477.2,491.7,477.1,491.7,477",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M491.6,477.3l5.3-1.8c0,0.1-0.1,0.2-0.1,0.2l-5.3,1.8C491.5,477.4,491.6,477.4,491.6,477.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M491.5,477.5l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2l-5.3,1.8C491.5,477.6,491.5,477.6,491.5,477.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M491.4,477.7l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0\n\t\t\t\t\t\t\tC491.4,477.8,491.4,477.7,491.4,477.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st461",
                                        attrs: {
                                          d: "M491.3,477.9l5.3-1.8c-0.1,0.2-0.2,0.3-0.3,0.5l-5.3,1.8C491.1,478.2,491.2,478,491.3,477.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st460",
                                        attrs: {
                                          d: "M491,478.3l5.3-1.8c-0.1,0.2-0.3,0.4-0.5,0.6l-5.3,1.8C490.7,478.7,490.9,478.5,491,478.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M490.6,479l5.3-1.8c-3.6,4.2-13.2,7.6-16.1,8.6l-5.3,1.8C477.4,486.6,487,483.1,490.6,479",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000135690390796587055990000007440627254212039837_",
                                        d: "M492.6,472l5.3-1.8\n\t\t\t\t\t\t\tc0,0.5-0.1,0.8-0.1,0.9l-5.3,1.8C492.5,472.8,492.5,472.5,492.6,472z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000149383568500957194130000008234311117607446712_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000135690390796587055990000007440627254212039837_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000149383568500957194130000008234311117607446712_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M492.6,472l5.3-1.8c0,0.3-0.1,0.6-0.1,0.7l-5.3,1.8C492.5,472.6,492.5,472.4,492.6,472",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M492.5,472.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C492.5,472.9,492.5,472.8,492.5,472.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M492.5,472.9l5.3-1.8c0,0,0,0,0,0L492.5,472.9C492.4,472.9,492.5,472.9,492.5,472.9",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000062893400298170640160000011152189797669328269_",
                                        d: "M493.2,463.1l5.3-1.8\n\t\t\t\t\t\t\tc-0.1,0.9-0.1,1.8-0.2,2.6l-5.3,1.8C493.1,464.8,493.2,464,493.2,463.1z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000098207833105497014800000001294015453190614675_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000062893400298170640160000011152189797669328269_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000098207833105497014800000001294015453190614675_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M493.2,463.1l5.3-1.8c0,0.6-0.1,1.3-0.1,1.8l-5.3,1.8C493.1,464.3,493.2,463.7,493.2,463.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st615",
                                        attrs: {
                                          d: "M493.1,464.9l5.3-1.8c0,0.3,0,0.5,0,0.7l-5.3,1.8C493.1,465.4,493.1,465.2,493.1,464.9",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000079480582311559967130000017965379340953453952_",
                                        d: "M493.2,464.5l5.3-1.8\n\t\t\t\t\t\t\tc-0.2,2.7-0.4,5.3-0.6,7.5l-5.3,1.8C492.8,469.8,493,467.2,493.2,464.5z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000049196939396024968610000015250193026209864618_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000079480582311559967130000017965379340953453952_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000049196939396024968610000015250193026209864618_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st615",
                                        attrs: {
                                          d: "M493.2,464.5l5.3-1.8c0,0.4,0,0.8-0.1,1.2l-5.3,1.8C493.1,465.3,493.2,464.9,493.2,464.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M493.1,465.7l5.3-1.8c-0.1,1.8-0.3,3.5-0.4,5l-5.3,1.8C492.9,469.2,493,467.5,493.1,465.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M492.7,470.7l5.3-1.8c0,0.4-0.1,0.9-0.1,1.3l-5.3,1.8C492.6,471.6,492.7,471.2,492.7,470.7",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000117663745993353763980000001998283979059760284_",
                                        d: "M499,445.3\n\t\t\t\t\t\t\tc-0.5,5.9-2.8,10.7-6.2,13.7c-1.8,0.6-3.5,1.2-5.3,1.8c3.5-2.9,5.8-7.7,6.2-13.7C495.3,446.5,497.4,445.8,499,445.3z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000090288965016491813540000006486016577002739115_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000117663745993353763980000001998283979059760284_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000090288965016491813540000006486016577002739115_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st614",
                                        attrs: {
                                          d: "M493.7,447.1l5.3-1.8c0,0.2,0,0.4,0,0.5l-5.3,1.8C493.7,447.4,493.7,447.2,493.7,447.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st613",
                                        attrs: {
                                          d: "M493.7,447.6l5.3-1.8c0,0.3-0.1,0.6-0.1,1l-5.3,1.8C493.6,448.2,493.7,447.9,493.7,447.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st612",
                                        attrs: {
                                          d: "M493.6,448.5l5.3-1.8c0,0.3-0.1,0.6-0.1,0.9l-5.3,1.8C493.5,449.2,493.5,448.9,493.6,448.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st611",
                                        attrs: {
                                          d: "M493.4,449.5l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C493.3,450.1,493.4,449.8,493.4,449.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st610",
                                        attrs: {
                                          d: "M493.2,450.4l5.3-1.8c-0.1,0.3-0.1,0.6-0.2,0.9l-5.3,1.8C493.1,451.1,493.2,450.7,493.2,450.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st455",
                                        attrs: {
                                          d: "M493,451.4l5.3-1.8c-0.1,0.3-0.2,0.6-0.3,0.9l-5.3,1.8C492.8,452,492.9,451.7,493,451.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st456",
                                        attrs: {
                                          d: "M492.8,452.3l5.3-1.8c-0.1,0.3-0.2,0.6-0.3,1l-5.3,1.8C492.5,453,492.7,452.6,492.8,452.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st457",
                                        attrs: {
                                          d: "M492.4,453.3l5.3-1.8c-0.1,0.3-0.2,0.7-0.4,1l-5.3,1.8C492.2,453.9,492.3,453.6,492.4,453.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st463",
                                        attrs: {
                                          d: "M492,454.3l5.3-1.8c-0.1,0.3-0.3,0.7-0.5,1l-5.3,1.8C491.8,455,491.9,454.6,492,454.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st462",
                                        attrs: {
                                          d: "M491.6,455.3l5.3-1.8c-0.2,0.4-0.4,0.7-0.6,1.1l-5.3,1.8C491.2,456,491.4,455.7,491.6,455.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st461",
                                        attrs: {
                                          d: "M491,456.4l5.3-1.8c-0.2,0.4-0.5,0.8-0.7,1.2l-5.3,1.8C490.6,457.2,490.8,456.8,491,456.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st460",
                                        attrs: {
                                          d: "M490.3,457.6l5.3-1.8c-0.3,0.5-0.7,1-1.1,1.4l-5.3,1.8C489.6,458.5,490,458,490.3,457.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st459",
                                        attrs: {
                                          d: "M489.2,459l5.3-1.8c-1.7,2-3.7,3.4-6.1,4.2l-5.3,1.8C485.5,462.4,487.6,460.9,489.2,459",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st639",
                                    attrs: {
                                      points:
                                        "493.7,447.1 499,445.3 498.5,461.3 493.2,463.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st640",
                                    attrs: {
                                      d: "M475.2,432.1c0.8,0.3,1.6,0.6,2.4,1l-0.5,17.5c-0.7-0.7-1.5-1.2-2.4-1.5c-3-1-5.6,1.3-5.7,5.2\n\t\t\t\t\t\ts2.2,7.8,5.3,8.8l0.2,0c10.1,3.2,18.3-4.2,19.3-16l-0.5,16c-0.1,0.9-0.1,1.8-0.2,2.6c0-0.4,0.1-0.7,0.1-1.1\n\t\t\t\t\t\tc-0.2,2.7-0.4,5.3-0.6,7.5c0,0.5-0.1,0.8-0.1,0.9c-0.3,2.4-0.7,4.2-1.1,4.9c-3,5.3-17,9.8-17.8,10c-0.4-0.4-7.3-7.2-12.2-13.4\n\t\t\t\t\t\tc-1.9-2.4-3.1-4.5-4-6c-0.3-0.6-0.5-1-0.8-1.6c-0.2-0.6-0.4-1.3-0.6-2.2c-0.3-1.6-0.4-4.3-0.5-7.1c-0.1-2.1-0.1-5.5-0.1-7.1\n\t\t\t\t\t\tc0-0.5,0-1.4,0-1.9c0.2-8.3,0.4-16.4,0.4-16.8c3-0.2,9.3-0.8,14.3-0.4C471.8,431.3,473.5,431.5,475.2,432.1z",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st641",
                                    attrs: {
                                      points:
                                        "493.8,446.1 499.1,444.3 499,445.3 493.7,447.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st640",
                                    attrs: {
                                      d: "M481.4,411.3l13.1,11.8l-0.7,23l0,0.9c-1,11.8-9.2,19.3-19.4,16c3,1,5.5-1.3,5.7-5l1.1-38.3L481.4,411.3\n\t\t\t\t\t\tz",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st630",
                                    attrs: {
                                      points:
                                        "494.4,423.1 499.7,421.3 499.1,444.3 493.8,446.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st642",
                                    attrs: {
                                      points:
                                        "481.4,411.3 486.7,409.5 499.7,421.3 494.4,423.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000129207497170354622850000003959158603521672354_",
                                        d: "M612.9,492.4l5.3-1.8\n\t\t\t\t\t\t\tc0.1,0,0.2,0,0.3-0.1c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.5,0.3,0.8,0.5c0.4,0.4,0.7,0.9,0.8,1.5c0.1,0.6,0,1.1-0.2,1.6l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.5,0.3-1,0.2-1.6c-0.1-0.6-0.4-1.1-0.8-1.5c-0.3-0.3-0.5-0.4-0.8-0.5c-0.2-0.1-0.3-0.1-0.5-0.1\n\t\t\t\t\t\t\tC613.1,492.3,613,492.3,612.9,492.4z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000062902331056771801590000009517735164455290760_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000129207497170354622850000003959158603521672354_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000062902331056771801590000009517735164455290760_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M612.9,492.4l5.3-1.8c0,0,0,0,0,0L612.9,492.4C612.9,492.4,612.9,492.4,612.9,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M612.9,492.4l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C613,492.3,613,492.3,612.9,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M613.1,492.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C613.2,492.3,613.1,492.3,613.1,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M613.2,492.3l5.3-1.8c0,0,0,0,0,0c0,0,0.1,0,0.1,0l-5.3,1.8C613.3,492.3,613.3,492.3,613.2,492.3\n\t\t\t\t\t\t\tC613.2,492.3,613.2,492.3,613.2,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M613.3,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.3,492.3C613.4,492.3,613.3,492.3,613.3,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M613.4,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.4,492.3C613.5,492.3,613.4,492.3,613.4,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M613.5,492.3l5.3-1.8c0,0,0.1,0,0.1,0L613.5,492.3C613.5,492.3,613.5,492.3,613.5,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M613.6,492.3l5.3-1.8c0,0,0,0,0.1,0L613.6,492.3C613.6,492.3,613.6,492.3,613.6,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M613.6,492.3l5.3-1.8c0,0,0,0,0.1,0L613.6,492.3C613.7,492.4,613.6,492.4,613.6,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M613.7,492.4l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L613.7,492.4C613.7,492.4,613.7,492.4,613.7,492.4\n\t\t\t\t\t\t\tC613.7,492.4,613.7,492.4,613.7,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M613.8,492.4l5.3-1.8c0,0,0,0,0.1,0L613.8,492.4C613.8,492.4,613.8,492.4,613.8,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M613.8,492.4l5.3-1.8c0,0,0,0,0.1,0L613.8,492.4C613.9,492.4,613.8,492.4,613.8,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M613.9,492.4l5.3-1.8c0,0,0,0,0.1,0L613.9,492.4C613.9,492.5,613.9,492.5,613.9,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M614,492.5l5.3-1.8c0,0,0,0,0.1,0L614,492.5C614,492.5,614,492.5,614,492.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M614,492.5l5.3-1.8c0,0,0,0,0.1,0L614,492.5C614.1,492.5,614,492.5,614,492.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M614.1,492.6l5.3-1.8c0,0,0,0,0.1,0L614.1,492.6C614.1,492.6,614.1,492.6,614.1,492.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M614.2,492.6l5.3-1.8c0,0,0.1,0,0.1,0.1L614.2,492.6C614.2,492.6,614.2,492.6,614.2,492.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M614.2,492.7l5.3-1.8c0,0,0.1,0,0.1,0.1L614.2,492.7C614.3,492.7,614.3,492.7,614.2,492.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M614.3,492.7l5.3-1.8c0,0,0.1,0.1,0.1,0.1L614.3,492.7C614.4,492.8,614.3,492.8,614.3,492.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M614.4,492.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1c0,0,0,0,0,0l-5.3,1.8C614.5,492.9,614.5,492.9,614.4,492.8\n\t\t\t\t\t\t\tC614.5,492.9,614.4,492.8,614.4,492.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M614.5,492.9l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C614.6,493,614.6,493,614.5,492.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M614.6,493l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C614.7,493.1,614.7,493.1,614.6,493",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M614.7,493.2l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C614.8,493.3,614.8,493.2,614.7,493.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M614.8,493.4l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.5l-5.3,1.8C615,493.7,615,493.5,614.8,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M615.1,493.9l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C615.2,494,615.1,494,615.1,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M615.2,494.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,494.2,615.2,494.1,615.2,494.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M615.2,494.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,494.3,615.2,494.3,615.2,494.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M615.2,494.4l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l-5.3,1.8C615.3,494.5,615.3,494.5,615.2,494.4\n\t\t\t\t\t\t\tC615.3,494.4,615.2,494.4,615.2,494.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M615.3,494.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.6,615.3,494.5,615.3,494.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M615.3,494.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.7,615.3,494.7,615.3,494.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M615.3,494.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.8,615.3,494.8,615.3,494.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M615.3,494.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,494.9,615.3,494.9,615.3,494.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M615.3,495l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,495,615.3,495,615.3,495",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M615.3,495.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.3,495.1,615.3,495.1,615.3,495.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M615.3,495.2l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.2C615.3,495.2,615.3,495.2,615.3,495.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M615.3,495.3l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.3C615.3,495.3,615.3,495.3,615.3,495.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M615.3,495.4l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.4C615.3,495.4,615.3,495.4,615.3,495.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M615.3,495.5l5.3-1.8c0,0,0,0.1,0,0.1L615.3,495.5C615.2,495.5,615.3,495.5,615.3,495.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M615.2,495.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.6,615.2,495.6,615.2,495.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M615.2,495.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.8,615.2,495.7,615.2,495.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M615.2,495.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.2,495.9,615.2,495.8,615.2,495.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M615.2,495.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C615.1,496,615.1,495.9,615.2,495.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M615.1,496l5.3-1.8c0,0,0,0,0,0L615.1,496C615.1,496,615.1,496,615.1,496",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000168094042691763501220000011571280251279237013_",
                                        d: "M632.3,514.6l-5.3,1.8\n\t\t\t\t\t\t\tc-0.2,0.1-0.4,0.1-0.6,0.2c-1.1,0.3-2.4,0.2-3.7-0.2c-1.3-0.4-2.5-1.1-3.6-2.1c-1.1-1-2.1-2.2-2.9-3.5\n\t\t\t\t\t\t\tc-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9c0.1-2.1,0.5-3.9,1.4-5.4l5.3-1.8c-0.8,1.5-1.3,3.3-1.4,5.4\n\t\t\t\t\t\t\tc0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.3,0.4,2.5,0.5,3.7,0.2\n\t\t\t\t\t\t\tC631.9,514.7,632.1,514.7,632.3,514.6z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000107552001414080755420000012161764324362981304_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000168094042691763501220000011571280251279237013_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000107552001414080755420000012161764324362981304_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M615.1,496l5.3-1.8c0,0,0,0,0,0L615.1,496C615.1,496.1,615.1,496,615.1,496",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M615.1,496.1l5.3-1.8c-0.1,0.2-0.2,0.3-0.3,0.5l-5.3,1.8C614.9,496.4,615,496.2,615.1,496.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M614.8,496.6l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C614.7,496.9,614.7,496.8,614.8,496.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M614.6,497.1l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C614.5,497.4,614.5,497.2,614.6,497.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M614.4,497.5l5.3-1.8c-0.1,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C614.3,497.8,614.4,497.7,614.4,497.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M614.3,498l5.3-1.8c0,0.1-0.1,0.3-0.1,0.4l-5.3,1.8C614.2,498.3,614.2,498.2,614.3,498",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M614.1,498.5l5.3-1.8c0,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C614.1,498.8,614.1,498.6,614.1,498.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M614,498.9l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C614,499.2,614,499.1,614,498.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M613.9,499.4l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C613.9,499.7,613.9,499.5,613.9,499.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M613.9,499.8l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C613.8,500.2,613.8,500,613.9,499.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M613.8,500.3l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C613.8,500.7,613.8,500.5,613.8,500.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M613.8,500.8l5.3-1.8c0,0.2,0,0.4,0,0.5l-5.3,1.8C613.7,501.2,613.7,501,613.8,500.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M613.7,501.4l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.4,0,0.5l-5.3,1.8C613.7,501.8,613.7,501.6,613.7,501.4\n\t\t\t\t\t\t\tC613.7,501.4,613.7,501.4,613.7,501.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M613.7,501.9l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C613.7,502.3,613.7,502.1,613.7,501.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M613.7,502.5l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C613.8,502.9,613.7,502.7,613.7,502.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M613.8,503.1l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C613.8,503.4,613.8,503.2,613.8,503.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M613.8,503.6l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C613.9,504,613.8,503.8,613.8,503.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M613.9,504.2l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C614,504.6,613.9,504.4,613.9,504.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M614,504.8l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7l-5.3,1.8C614.1,505.3,614,505.1,614,504.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M614.1,505.5l5.3-1.8c0.1,0.3,0.1,0.5,0.2,0.8c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1\n\t\t\t\t\t\t\tC614.3,506,614.2,505.8,614.1,505.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M614.4,506.3l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C614.6,507.1,614.5,506.7,614.4,506.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M614.7,507.5l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.2c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.2-0.2-0.3C615.6,509.7,615.1,508.6,614.7,507.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M616.4,511l5.3-1.8c0.2,0.4,0.5,0.7,0.7,1l-5.3,1.8C616.9,511.7,616.7,511.4,616.4,511",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M617.2,512.1l5.3-1.8c0.2,0.3,0.4,0.5,0.6,0.7l-5.3,1.8C617.6,512.6,617.4,512.3,617.2,512.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M617.8,512.8l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C618.1,513.2,617.9,513,617.8,512.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M618.3,513.4l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.5l-5.3,1.8C618.6,513.7,618.5,513.6,618.3,513.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M618.8,513.9l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0,0,0.1,0.1,0.1,0.1l-5.3,1.8c0,0-0.1-0.1-0.1-0.1\n\t\t\t\t\t\t\tC619,514.1,618.9,514,618.8,513.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M619.2,514.3l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C619.5,514.5,619.4,514.4,619.2,514.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M619.6,514.6l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C619.9,514.8,619.8,514.7,619.6,514.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M620,514.9l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C620.3,515.1,620.1,515,620,514.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M620.4,515.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C620.6,515.3,620.5,515.3,620.4,515.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M620.8,515.4l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621,515.6,620.9,515.5,620.8,515.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M621.1,515.6l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621.4,515.8,621.3,515.7,621.1,515.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M621.5,515.8l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C621.8,516,621.7,515.9,621.5,515.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M621.9,516l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C622.2,516.1,622.1,516.1,621.9,516",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M622.4,516.2l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0\n\t\t\t\t\t\t\tC622.6,516.3,622.5,516.2,622.4,516.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M622.8,516.3l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C623.1,516.4,622.9,516.4,622.8,516.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M623.2,516.5l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C623.5,516.5,623.4,516.5,623.2,516.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M623.7,516.6l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C624,516.6,623.8,516.6,623.7,516.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M624.1,516.6l5.3-1.8c0.2,0,0.3,0,0.4,0l-5.3,1.8C624.4,516.7,624.3,516.7,624.1,516.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M624.6,516.7l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C624.9,516.7,624.7,516.7,624.6,516.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M625,516.7l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C625.4,516.7,625.2,516.7,625,516.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M625.5,516.7l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C625.9,516.6,625.7,516.7,625.5,516.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M626.1,516.6l5.3-1.8c0.1,0,0.2,0,0.3-0.1c0.2,0,0.4-0.1,0.5-0.1l-5.3,1.8c-0.2,0.1-0.4,0.1-0.5,0.1\n\t\t\t\t\t\t\tC626.3,516.6,626.2,516.6,626.1,516.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M626.9,516.4l5.3-1.8c0,0,0.1,0,0.1,0L626.9,516.4C627,516.4,626.9,516.4,626.9,516.4",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000132782784030628559600000004675830065832954800_",
                                        d: "M619.2,492.4l5.3-1.8\n\t\t\t\t\t\t\tc-0.1,0-0.3,0.1-0.4,0.1l-5.3,1.8C619,492.5,619.1,492.5,619.2,492.4z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000181076275087896651990000001101155434638831776_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000132782784030628559600000004675830065832954800_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000181076275087896651990000001101155434638831776_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M619.2,492.4l5.3-1.8c-0.1,0-0.3,0.1-0.4,0.1l-5.3,1.8C619,492.5,619.1,492.5,619.2,492.4",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000114031729839878173550000012990982679381937085_",
                                        d: "M617.5,488.2l5.3-1.8\n\t\t\t\t\t\t\tc1.9-0.6,3.9-0.6,6,0.1l-5.3,1.8C621.4,487.6,619.4,487.6,617.5,488.2z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000134947610107001600470000012297033906149646482_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000114031729839878173550000012990982679381937085_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000134947610107001600470000012297033906149646482_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M617.5,488.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C617.6,488.2,617.5,488.2,617.5,488.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M617.6,488.2l5.3-1.8c0.4-0.1,0.7-0.2,1.1-0.3l-5.3,1.8C618.4,488,618,488.1,617.6,488.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M618.7,487.9l5.3-1.8c0.3-0.1,0.6-0.1,0.9-0.1l-5.3,1.8C619.3,487.8,619,487.8,618.7,487.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M619.6,487.8l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C620.1,487.7,619.9,487.8,619.6,487.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M620.3,487.7l5.3-1.8c0.2,0,0.4,0,0.7,0l-5.3,1.8C620.8,487.8,620.6,487.7,620.3,487.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M621,487.8l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C621.4,487.8,621.2,487.8,621,487.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M621.7,487.8l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C622.1,487.9,621.9,487.9,621.7,487.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M622.3,487.9l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C622.7,488,622.5,488,622.3,487.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M622.8,488.1l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C623.2,488.2,623,488.1,622.8,488.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M623.4,488.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C623.5,488.3,623.5,488.2,623.4,488.2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M623.5,488.3c1.7,0.6,3.4,1.5,4.9,2.9c1.5,1.3,2.8,2.9,3.9,4.8c1.1,1.8,1.9,3.8,2.5,6\n\t\t\t\t\t\tc0.6,2.2,0.9,4.4,0.8,6.6c-0.1,2.2-0.5,4.2-1.2,6c-0.7,1.7-1.7,3.2-2.8,4.2c-1.2,1.1-2.5,1.8-4.1,2.2c-1.6,0.3-3.2,0.2-5-0.3\n\t\t\t\t\t\tc-1.7-0.6-3.4-1.5-4.9-2.8c-1.5-1.3-2.8-2.9-3.9-4.7c-1.1-1.8-2-3.8-2.6-6c-0.6-2.2-0.9-4.4-0.8-6.6c0.1-2.8,0.7-5.2,1.8-7.3\n\t\t\t\t\t\tc0.2-0.5,0.6-0.7,1-0.7c0.2,0,0.3,0,0.5,0.1c0.3,0.1,0.5,0.3,0.8,0.5c0.4,0.4,0.7,0.9,0.8,1.5c0.1,0.6,0,1.1-0.2,1.6\n\t\t\t\t\t\tc-0.8,1.5-1.3,3.3-1.4,5.4c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1\n\t\t\t\t\t\tc1.3,0.4,2.5,0.5,3.7,0.2c1.1-0.3,2.1-0.8,3-1.6c0.9-0.8,1.6-1.8,2.1-3.1c0.5-1.3,0.8-2.7,0.9-4.4c0-1.6-0.2-3.3-0.6-4.9\n\t\t\t\t\t\ts-1.1-3.1-1.9-4.4c-0.8-1.4-1.8-2.5-2.9-3.5c-1.1-1-2.3-1.7-3.6-2.1c-1.6-0.5-3.2-0.5-4.6,0.1c-0.3,0.1-0.5,0.1-0.8,0\n\t\t\t\t\t\tc-0.2-0.1-0.3-0.1-0.5-0.3c-0.4-0.3-0.8-0.8-1-1.4c-0.2-0.6-0.3-1.2-0.1-1.7c0.1-0.5,0.4-0.8,0.8-1\n\t\t\t\t\t\tC619.3,487.6,621.4,487.6,623.5,488.3z",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000063599483011043737950000000139128218140693648_",
                                        d: "M633.8,518.8l-5.3,1.8\n\t\t\t\t\t\t\tc1.2-0.4,2.2-1,3.2-1.9c1.2-1.1,2.1-2.5,2.8-4.2c0.7-1.7,1.1-3.7,1.2-6c0.1-2.2-0.2-4.4-0.8-6.6c-0.6-2.2-1.4-4.2-2.5-6\n\t\t\t\t\t\t\tc-1.1-1.8-2.4-3.4-3.9-4.8c-1.5-1.3-3.1-2.3-4.9-2.9l5.3-1.8c1.7,0.6,3.4,1.5,4.9,2.9c1.5,1.3,2.8,2.9,3.9,4.8\n\t\t\t\t\t\t\tc1.1,1.8,1.9,3.8,2.5,6c0.6,2.2,0.9,4.4,0.8,6.6c-0.1,2.2-0.5,4.2-1.2,6c-0.7,1.7-1.7,3.2-2.8,4.2\n\t\t\t\t\t\t\tC636,517.8,634.9,518.4,633.8,518.8z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000171719178324069841150000008126227724445730732_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000063599483011043737950000000139128218140693648_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000171719178324069841150000008126227724445730732_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M623.5,488.3l5.3-1.8c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8C623.9,488.4,623.7,488.3,623.5,488.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M624,488.4l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C624.4,488.6,624.2,488.5,624,488.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M624.6,488.7l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2l-5.3,1.8C625,488.8,624.8,488.7,624.6,488.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M625.1,488.9l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C625.5,489.1,625.3,489,625.1,488.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M625.7,489.2l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C626,489.4,625.9,489.3,625.7,489.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M626.2,489.5l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C626.6,489.7,626.4,489.6,626.2,489.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M626.7,489.8l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.4l-5.3,1.8C627.1,490.1,626.9,489.9,626.7,489.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M627.3,490.2l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C627.6,490.4,627.4,490.3,627.3,490.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M627.8,490.6l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C628.2,490.9,628,490.7,627.8,490.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M628.3,491l5.3-1.8c0,0,0.1,0.1,0.1,0.1c0.2,0.1,0.3,0.3,0.5,0.5l-5.3,1.8c-0.2-0.2-0.3-0.3-0.5-0.5\n\t\t\t\t\t\t\tC628.4,491.1,628.4,491.1,628.3,491",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M628.9,491.6l5.3-1.8c0.2,0.2,0.5,0.4,0.7,0.7l-5.3,1.8C629.4,492,629.2,491.8,628.9,491.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M629.6,492.3l5.3-1.8c0.2,0.3,0.5,0.5,0.7,0.8l-5.3,1.8C630.1,492.8,629.9,492.5,629.6,492.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M630.3,493.1l5.3-1.8c0.3,0.3,0.5,0.6,0.8,1l-5.3,1.8C630.9,493.7,630.6,493.4,630.3,493.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M631.1,494l5.3-1.8c0.3,0.4,0.6,0.9,0.9,1.4l-5.3,1.8C631.7,494.9,631.4,494.5,631.1,494",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M632,495.4l5.3-1.8c0.1,0.2,0.2,0.3,0.3,0.5c0.8,1.3,1.4,2.7,1.9,4.1l-5.3,1.8\n\t\t\t\t\t\t\tc-0.5-1.5-1.2-2.8-1.9-4.1C632.3,495.7,632.2,495.6,632,495.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M634.3,500l5.3-1.8c0.2,0.5,0.4,1.1,0.5,1.6l-5.3,1.8C634.7,501.1,634.5,500.6,634.3,500",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M634.8,501.6l5.3-1.8c0,0.1,0,0.2,0.1,0.3c0.1,0.3,0.1,0.6,0.2,0.8l-5.3,1.8c-0.1-0.3-0.1-0.6-0.2-0.8\n\t\t\t\t\t\t\tC634.9,501.8,634.8,501.7,634.8,501.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M635.1,502.7l5.3-1.8c0.1,0.3,0.1,0.6,0.2,1l-5.3,1.8C635.2,503.4,635.2,503,635.1,502.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M635.3,503.7l5.3-1.8c0.1,0.3,0.1,0.6,0.1,0.9l-5.3,1.8C635.4,504.3,635.4,504,635.3,503.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M635.5,504.6l5.3-1.8c0,0.3,0.1,0.6,0.1,0.8l-5.3,1.8C635.5,505.1,635.5,504.8,635.5,504.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M635.6,505.4l5.3-1.8c0,0.3,0.1,0.5,0.1,0.8l-5.3,1.8C635.6,505.9,635.6,505.7,635.6,505.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M635.6,506.2l5.3-1.8c0,0.3,0,0.5,0,0.8l-5.3,1.8C635.7,506.7,635.7,506.5,635.6,506.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M635.7,507l5.3-1.8c0,0.3,0,0.5,0,0.8l-5.3,1.8C635.7,507.5,635.7,507.3,635.7,507",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M635.7,507.8l5.3-1.8c0,0.2,0,0.5,0,0.7c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1\n\t\t\t\t\t\t\tC635.7,508.3,635.7,508,635.7,507.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M635.7,508.6l5.3-1.8c0,0.3,0,0.5,0,0.7l-5.3,1.8C635.7,509.1,635.7,508.8,635.7,508.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M635.7,509.3l5.3-1.8c0,0.2,0,0.5-0.1,0.7l-5.3,1.8C635.6,509.8,635.6,509.5,635.7,509.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M635.6,510l5.3-1.8c0,0.2,0,0.4-0.1,0.7l-5.3,1.8C635.5,510.4,635.6,510.2,635.6,510",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M635.5,510.7l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.5,511.1,635.5,510.9,635.5,510.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M635.4,511.3l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.3,511.7,635.4,511.5,635.4,511.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M635.3,511.9l5.3-1.8c0,0.2-0.1,0.4-0.1,0.6l-5.3,1.8C635.2,512.4,635.2,512.2,635.3,511.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M635.1,512.6l5.3-1.8c-0.1,0.2-0.1,0.4-0.2,0.6l-5.3,1.8C635,513,635.1,512.8,635.1,512.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M635,513.2l5.3-1.8c-0.1,0.2-0.1,0.4-0.2,0.6l-5.3,1.8C634.8,513.6,634.9,513.4,635,513.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M634.8,513.8l5.3-1.8c-0.1,0.2-0.2,0.4-0.2,0.6c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0\n\t\t\t\t\t\t\tC634.6,514.3,634.7,514,634.8,513.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M634.5,514.5l5.3-1.8c-0.1,0.3-0.2,0.5-0.4,0.8l-5.3,1.8C634.3,515,634.4,514.7,634.5,514.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M634.2,515.3l5.3-1.8c-0.1,0.3-0.3,0.5-0.4,0.8l-5.3,1.8C633.9,515.8,634,515.5,634.2,515.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M633.8,516l5.3-1.8c-0.2,0.3-0.3,0.5-0.5,0.8l-5.3,1.8C633.4,516.6,633.6,516.3,633.8,516",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M633.3,516.8l5.3-1.8c-0.2,0.3-0.5,0.6-0.7,0.9l-5.3,1.8C632.8,517.5,633,517.2,633.3,516.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M632.6,517.8l5.3-1.8c-0.3,0.3-0.6,0.7-0.9,0.9c-0.9,0.9-2,1.5-3.2,1.9l-5.3,1.8c1.2-0.4,2.2-1,3.2-1.9\n\t\t\t\t\t\t\tC632,518.4,632.3,518.1,632.6,517.8",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000039830806908572362550000015036273077569078956_",
                                        d: "M602.7,510.4l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.3-0.1,0.4-0.3c0.3-0.3,0.5-0.8,0.5-1.4l5.3-1.8c0,0.6-0.2,1.1-0.5,1.4C603,510.2,602.9,510.3,602.7,510.4z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000077298283285638824790000010376499410890252178_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000039830806908572362550000015036273077569078956_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000077298283285638824790000010376499410890252178_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("polyline", {
                                        staticClass: "st658",
                                        attrs: {
                                          points:
                                            "598.4,510.5 603.7,508.7 603.7,508.7 598.4,510.5 598.4,510.5 \t\t\t\t\t\t",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M598.4,510.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.6,598.4,510.5,598.4,510.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M598.4,510.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.7,598.4,510.6,598.4,510.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M598.4,510.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C598.4,510.8,598.4,510.7,598.4,510.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M598.4,510.8l5.3-1.8c0,0,0,0.1,0,0.1L598.4,510.8C598.3,510.9,598.4,510.9,598.4,510.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M598.3,510.9l5.3-1.8c0,0,0,0.1,0,0.1L598.3,510.9C598.3,511,598.3,511,598.3,510.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M598.3,511l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511C598.3,511.1,598.3,511,598.3,511",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M598.3,511.1l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511.1C598.3,511.2,598.3,511.1,598.3,511.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M598.3,511.2l5.3-1.8c0,0,0,0.1,0,0.1L598.3,511.2C598.3,511.2,598.3,511.2,598.3,511.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M598.2,511.3l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.3C598.2,511.3,598.2,511.3,598.2,511.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M598.2,511.4l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.4C598.2,511.4,598.2,511.4,598.2,511.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M598.2,511.4l5.3-1.8c0,0,0,0.1,0,0.1L598.2,511.4C598.1,511.5,598.2,511.5,598.2,511.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M598.1,511.5l5.3-1.8c0,0,0,0.1-0.1,0.1L598.1,511.5C598.1,511.6,598.1,511.6,598.1,511.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M598.1,511.6l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C598,511.7,598,511.7,598.1,511.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M598,511.8l5.3-1.8c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.3,0.2-0.4,0.3l-5.3,1.8c0.2-0.1,0.3-0.1,0.4-0.3\n\t\t\t\t\t\t\tC597.9,511.8,597.9,511.8,598,511.8",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "598.5,507.9 603.7,506.1 603.7,508.7 598.4,510.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "598.5,507.3 603.8,505.6 603.7,506.1 598.5,507.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M598.6,503.1l-0.1,4.2l0,0.6l-0.1,2.5c0,0.6-0.2,1.1-0.5,1.4c-0.3,0.3-0.7,0.4-1.2,0.2\n\t\t\t\t\t\tc-0.5-0.2-0.9-0.5-1.2-1c-0.3-0.5-0.5-1.1-0.4-1.7l0.1-2.5l0-0.6l0.1-4.2L598.6,503.1z",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "598.6,503.1 603.9,501.4 603.8,505.6 598.5,507.3 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "595.3,502 600.6,500.3 603.9,501.4 598.6,503.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "598.7,499 604,497.3 603.9,499.4 598.7,501.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "598.8,497 604.1,495.2 604,497.3 598.7,499 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000089574599315423773790000011216563751677216669_",
                                        d: "M596.8,479.7l5.3-1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.1,0.8,0l-5.3,1.8C597.3,479.6,597.1,479.6,596.8,479.7z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000160148084411026225880000013327060818211428521_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000089574599315423773790000011216563751677216669_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000160148084411026225880000013327060818211428521_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M596.8,479.7l5.3-1.8c0,0,0,0,0,0L596.8,479.7C596.8,479.7,596.8,479.7,596.8,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M596.8,479.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C596.9,479.6,596.9,479.7,596.8,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M597,479.6l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597,479.6,597,479.6,597,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M597.1,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.1,479.6C597.1,479.6,597.1,479.6,597.1,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M597.2,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.2,479.6C597.2,479.6,597.2,479.6,597.2,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M597.3,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.3,479.6C597.3,479.6,597.3,479.6,597.3,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M597.3,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.3,479.6C597.4,479.6,597.4,479.6,597.3,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M597.4,479.6l5.3-1.8c0,0,0.1,0,0.1,0L597.4,479.6C597.5,479.7,597.5,479.6,597.4,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M597.5,479.7l5.3-1.8c0,0,0.1,0,0.1,0L597.5,479.7C597.6,479.7,597.6,479.7,597.5,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M597.6,479.7l5.3-1.8c0,0,0,0,0,0L597.6,479.7C597.6,479.7,597.6,479.7,597.6,479.7",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "599.2,482.4 604.5,480.6 604.1,495.2 598.8,497 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000133514726964279219070000010949542666360762039_",
                                        d: "M597.6,479.7l5.3-1.8\n\t\t\t\t\t\t\tc0.4,0.1,0.8,0.5,1.1,1l-5.3,1.8C598.5,480.2,598.1,479.8,597.6,479.7z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000165928078289281796680000005467570382223767179_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000133514726964279219070000010949542666360762039_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000165928078289281796680000005467570382223767179_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M597.6,479.7l5.3-1.8c0,0,0,0,0.1,0L597.6,479.7C597.7,479.7,597.7,479.7,597.6,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M597.7,479.7l5.3-1.8c0,0,0,0,0.1,0L597.7,479.7C597.7,479.7,597.7,479.7,597.7,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M597.8,479.7l5.3-1.8c0,0,0,0,0.1,0L597.8,479.7C597.8,479.8,597.8,479.8,597.8,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M597.8,479.8l5.3-1.8c0,0,0,0,0.1,0L597.8,479.8C597.9,479.8,597.9,479.8,597.8,479.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M597.9,479.8l5.3-1.8c0,0,0,0,0.1,0L597.9,479.8C598,479.8,597.9,479.8,597.9,479.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M598,479.8l5.3-1.8c0,0,0,0,0.1,0L598,479.8C598,479.9,598,479.9,598,479.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M598,479.9l5.3-1.8c0,0,0,0,0.1,0L598,479.9C598.1,479.9,598.1,479.9,598,479.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M598.1,479.9l5.3-1.8c0,0,0,0,0.1,0.1L598.1,479.9C598.2,480,598.1,480,598.1,479.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M598.2,480l5.3-1.8c0,0,0,0,0.1,0.1L598.2,480C598.2,480,598.2,480,598.2,480",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M598.2,480l5.3-1.8c0,0,0,0,0.1,0.1L598.2,480C598.3,480.1,598.3,480.1,598.2,480",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M598.3,480.1l5.3-1.8c0,0,0.1,0.1,0.1,0.1L598.3,480.1C598.4,480.2,598.3,480.1,598.3,480.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M598.4,480.2l5.3-1.8c0,0,0.1,0.1,0.1,0.1L598.4,480.2C598.5,480.3,598.4,480.2,598.4,480.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M598.5,480.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.5,480.4,598.5,480.3,598.5,480.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M598.6,480.4l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C598.7,480.5,598.6,480.5,598.6,480.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M598.7,480.6l5.3-1.8c0,0,0,0.1,0,0.1L598.7,480.6C598.7,480.7,598.7,480.6,598.7,480.6",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M597.6,479.7c0.4,0.1,0.8,0.5,1.1,1c0.3,0.5,0.4,1.1,0.4,1.7l-0.4,14.6l-0.1,2l-0.1,2.2l-3.3-1.1\n\t\t\t\t\t\tl0.1-2.2l0.1-2l0.4-14.6c0-0.6,0.2-1.1,0.5-1.4C596.7,479.6,597.1,479.5,597.6,479.7z",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000019667339594492453590000003519155608054967463_",
                                        d: "M598.8,480.7l5.3-1.8\n\t\t\t\t\t\t\tc0.3,0.5,0.4,1.1,0.4,1.7l-5.3,1.8C599.2,481.8,599.1,481.2,598.8,480.7z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000061430114595752432400000005906143538047538057_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000019667339594492453590000003519155608054967463_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000061430114595752432400000005906143538047538057_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M598.8,480.7l5.3-1.8c0.1,0.2,0.2,0.3,0.2,0.5l-5.3,1.8C598.9,481,598.9,480.9,598.8,480.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M599,481.2l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C599,481.3,599,481.3,599,481.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M599.1,481.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.1,481.5,599.1,481.4,599.1,481.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M599.1,481.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.1,481.6,599.1,481.6,599.1,481.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M599.1,481.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,481.8,599.1,481.7,599.1,481.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M599.2,481.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,481.9,599.2,481.8,599.2,481.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M599.2,481.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482,599.2,482,599.2,481.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M599.2,482.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.1,599.2,482.1,599.2,482.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M599.2,482.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.3,599.2,482.2,599.2,482.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M599.2,482.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C599.2,482.4,599.2,482.3,599.2,482.3",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000038404880807425324500000002517481041474823614_",
                                        d: "M596.8,471.1l5.3-1.8\n\t\t\t\t\t\t\tc0.3-0.1,0.7-0.1,1.1,0l-5.3,1.8C597.5,471,597.1,471,596.8,471.1z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000052809302343135985410000001696324287678190527_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000038404880807425324500000002517481041474823614_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000052809302343135985410000001696324287678190527_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M596.8,471.1l5.3-1.8c0,0,0,0,0,0L596.8,471.1C596.8,471.1,596.8,471.1,596.8,471.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M596.8,471.1l5.3-1.8c0.1,0,0.1,0,0.2,0L597,471C596.9,471,596.8,471.1,596.8,471.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M597,471l5.3-1.8c0,0,0.1,0,0.2,0l-5.3,1.8C597.1,471,597,471,597,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M597.1,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.2,471,597.2,471,597.1,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M597.3,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.3,471,597.3,471,597.3,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M597.4,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.5,471,597.4,471,597.4,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M597.5,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.6,471,597.5,471,597.5,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M597.6,471l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.7,471.1,597.7,471,597.6,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M597.8,471.1l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C597.8,471.1,597.8,471.1,597.8,471.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M597.9,471.1l5.3-1.8c0,0,0,0,0,0L597.9,471.1C597.9,471.1,597.9,471.1,597.9,471.1",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M597.9,471.1c0.6,0.2,1.2,0.7,1.7,1.5c0.5,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.5-0.8,2\n\t\t\t\t\t\tc-0.5,0.5-1.1,0.6-1.7,0.4c-0.7-0.2-1.3-0.7-1.7-1.5c-0.5-0.8-0.7-1.6-0.6-2.4c0-0.9,0.3-1.5,0.8-2\n\t\t\t\t\t\tC596.6,471,597.2,470.9,597.9,471.1z",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000065063102388052859840000016903077010704873134_",
                                        d: "M604.1,475.6l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.2,0.7-0.4c0.5-0.5,0.8-1.1,0.8-2c0-0.9-0.2-1.7-0.7-2.5c-0.5-0.8-1-1.2-1.7-1.5l5.3-1.8\n\t\t\t\t\t\t\tc0.6,0.2,1.2,0.7,1.7,1.5c0.5,0.8,0.7,1.6,0.7,2.5c0,0.8-0.3,1.5-0.8,2C604.5,475.4,604.3,475.5,604.1,475.6z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000173868232858261225670000013318379702494306453_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000065063102388052859840000016903077010704873134_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000173868232858261225670000013318379702494306453_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M597.9,471.1l5.3-1.8c0,0,0.1,0,0.1,0L597.9,471.1C598,471.1,597.9,471.1,597.9,471.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M598,471.1l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C598.1,471.2,598,471.2,598,471.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M598.1,471.2l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C598.2,471.2,598.1,471.2,598.1,471.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M598.2,471.2l5.3-1.8c0,0,0.1,0,0.1,0.1L598.2,471.2C598.3,471.3,598.2,471.2,598.2,471.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M598.3,471.3l5.3-1.8c0,0,0.1,0,0.1,0.1L598.3,471.3C598.4,471.3,598.3,471.3,598.3,471.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M598.4,471.3l5.3-1.8c0,0,0.1,0,0.1,0.1L598.4,471.3C598.5,471.4,598.4,471.4,598.4,471.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M598.5,471.4l5.3-1.8c0,0,0.1,0,0.1,0.1L598.5,471.4C598.6,471.4,598.5,471.4,598.5,471.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M598.6,471.5l5.3-1.8c0,0,0.1,0,0.1,0.1L598.6,471.5C598.7,471.5,598.6,471.5,598.6,471.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M598.7,471.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.8,471.6,598.7,471.6,598.7,471.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M598.8,471.6l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C598.9,471.7,598.8,471.7,598.8,471.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M598.9,471.7l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C599,471.8,598.9,471.8,598.9,471.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M599,471.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C599.1,471.9,599.1,471.9,599,471.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M599.1,472l5.3-1.8c0.1,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C599.2,472.1,599.2,472,599.1,472",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M599.3,472.2l5.3-1.8c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8C599.4,472.4,599.4,472.3,599.3,472.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M599.5,472.5l5.3-1.8c0,0,0,0.1,0.1,0.1c0.2,0.3,0.3,0.5,0.4,0.8l-5.3,1.8c-0.1-0.3-0.2-0.6-0.4-0.8\n\t\t\t\t\t\t\tC599.5,472.5,599.5,472.5,599.5,472.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M600,473.4l5.3-1.8c0,0.1,0.1,0.2,0.1,0.3l-5.3,1.8C600,473.6,600,473.5,600,473.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M600,473.7l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C600.1,473.8,600.1,473.7,600,473.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M600.1,473.9l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.1,474,600.1,473.9,600.1,473.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M600.1,474.1l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.2,600.2,474.1,600.1,474.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M600.2,474.2l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.3,600.2,474.3,600.2,474.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M600.2,474.4l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.5,600.2,474.4,600.2,474.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M600.2,474.6l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.7,600.2,474.6,600.2,474.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M600.2,474.7l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C600.2,474.8,600.2,474.8,600.2,474.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M600.2,474.9l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0\n\t\t\t\t\t\t\tC600.2,475,600.2,474.9,600.2,474.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M600.2,475l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.1,600.2,475.1,600.2,475",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M600.2,475.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.3,600.2,475.2,600.2,475.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M600.2,475.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.4,600.2,475.4,600.2,475.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M600.2,475.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.2,475.5,600.2,475.5,600.2,475.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M600.2,475.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.6,600.2,475.6,600.2,475.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M600.1,475.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.8,600.1,475.7,600.1,475.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M600.1,475.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600.1,475.9,600.1,475.8,600.1,475.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M600.1,475.9l5.3-1.8c0,0,0,0.1,0,0.1L600,476C600.1,476,600.1,476,600.1,475.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M600,476l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C600,476.1,600,476.1,600,476",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M600,476.2l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C600,476.2,600,476.2,600,476.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M599.9,476.3l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C599.9,476.4,599.9,476.3,599.9,476.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M599.9,476.4l5.3-1.8c0,0.1-0.1,0.1-0.1,0.2l-5.3,1.8C599.8,476.5,599.8,476.5,599.9,476.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M599.8,476.6l5.3-1.8c0,0.1-0.1,0.1-0.2,0.2l-5.3,1.8C599.7,476.7,599.7,476.7,599.8,476.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M599.6,476.8l5.3-1.8c-0.1,0.1-0.1,0.1-0.2,0.2c-0.2,0.2-0.4,0.3-0.7,0.4l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.2,0.7-0.4C599.5,476.9,599.6,476.9,599.6,476.8",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000109710921183913761160000003713375258898373258_",
                                        d: "M549,469.6l5.3-1.8\n\t\t\t\t\t\t\tc-0.9,0.3-1.7,0.8-2.4,1.4c-0.9,0.8-1.6,1.8-2.1,3.1c-0.5,1.3-0.8,2.8-0.9,4.4c0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4\n\t\t\t\t\t\t\tc0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.5,0.5,3,0.5,4.3,0.1l-5.3,1.8c-1.3,0.4-2.8,0.4-4.3-0.1\n\t\t\t\t\t\t\tc-1.3-0.4-2.5-1.1-3.6-2.1c-1.1-1-2.1-2.2-2.9-3.5c-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9s0.3-3.1,0.9-4.4\n\t\t\t\t\t\t\tc0.5-1.3,1.2-2.3,2.1-3.1C547.3,470.4,548.1,469.9,549,469.6z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000111149983663625220790000005779819152401151113_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000109710921183913761160000003713375258898373258_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000111149983663625220790000005779819152401151113_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M549,469.6l5.3-1.8c-0.9,0.3-1.7,0.8-2.4,1.4c-0.2,0.2-0.5,0.5-0.7,0.7l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.3,0.4-0.5,0.7-0.7C547.3,470.4,548.1,469.9,549,469.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M545.9,471.7l5.3-1.8c-0.2,0.2-0.4,0.4-0.5,0.7l-5.3,1.8C545.6,472.2,545.8,471.9,545.9,471.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M545.4,472.4l5.3-1.8c-0.1,0.2-0.3,0.4-0.4,0.6l-5.3,1.8C545.2,472.8,545.3,472.6,545.4,472.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M545.1,473l5.3-1.8c-0.1,0.2-0.2,0.4-0.3,0.6l-5.3,1.8C544.9,473.4,545,473.2,545.1,473",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M544.8,473.6l5.3-1.8c-0.1,0.2-0.2,0.4-0.2,0.5c0,0,0,0,0,0l-5.3,1.8c0,0,0,0,0,0\n\t\t\t\t\t\t\tC544.6,474,544.7,473.8,544.8,473.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M544.5,474.2l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C544.4,474.5,544.4,474.3,544.5,474.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M544.3,474.7l5.3-1.8c-0.1,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C544.2,475,544.3,474.8,544.3,474.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M544.2,475.1l5.3-1.8c0,0.1-0.1,0.3-0.1,0.4l-5.3,1.8C544.1,475.4,544.1,475.3,544.2,475.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M544,475.6l5.3-1.8c0,0.1-0.1,0.3-0.1,0.5l-5.3,1.8C544,475.9,544,475.7,544,475.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M543.9,476l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C543.9,476.3,543.9,476.2,543.9,476",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M543.8,476.5l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C543.8,476.8,543.8,476.6,543.8,476.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M543.8,477l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C543.7,477.3,543.7,477.1,543.8,477",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M543.7,477.4l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C543.7,477.8,543.7,477.6,543.7,477.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M543.7,478l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.6,478.3,543.7,478.1,543.7,478",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M543.6,478.5l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.4,0,0.5l-5.3,1.8C543.6,478.9,543.6,478.7,543.6,478.5\n\t\t\t\t\t\t\tC543.6,478.5,543.6,478.5,543.6,478.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M543.6,479.1l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.6,479.5,543.6,479.3,543.6,479.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M543.6,479.7l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C543.7,480,543.6,479.8,543.6,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M543.7,480.2l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C543.7,480.6,543.7,480.4,543.7,480.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M543.7,480.8l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C543.8,481.2,543.7,481,543.7,480.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M543.8,481.4l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C543.9,481.8,543.8,481.6,543.8,481.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M543.9,482.1l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7l-5.3,1.8C544,482.5,544,482.3,543.9,482.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M544.1,482.7l5.3-1.8c0.1,0.2,0.1,0.5,0.2,0.7c0,0,0,0.1,0,0.1l-5.3,1.8c0,0,0-0.1,0-0.1\n\t\t\t\t\t\t\tC544.2,483.2,544.1,483,544.1,482.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M544.3,483.5l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C544.5,484.3,544.4,483.9,544.3,483.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M544.6,484.7l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.1c0.1,0.1,0.2,0.3,0.3,0.4l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.3-0.3-0.4C545.5,486.9,545.1,485.8,544.6,484.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M546.4,488.3l5.3-1.8c0.2,0.3,0.4,0.7,0.7,1l-5.3,1.8C546.9,489,546.6,488.7,546.4,488.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M547.1,489.3l5.3-1.8c0.2,0.2,0.4,0.5,0.6,0.7l-5.3,1.8C547.5,489.8,547.3,489.5,547.1,489.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M547.7,490l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C548,490.4,547.8,490.2,547.7,490",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M548.2,490.6l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.5l-5.3,1.8C548.5,491,548.4,490.8,548.2,490.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M548.7,491.1l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.1-0.2-0.2C548.9,491.3,548.8,491.2,548.7,491.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M549.2,491.5l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C549.4,491.8,549.3,491.7,549.2,491.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M549.6,491.9l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C549.8,492.1,549.7,492,549.6,491.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M549.9,492.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C550.2,492.3,550.1,492.2,549.9,492.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M550.3,492.4l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C550.5,492.6,550.4,492.5,550.3,492.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M550.7,492.6l5.3-1.8c0.1,0.1,0.2,0.1,0.4,0.2l-5.3,1.8C550.9,492.8,550.8,492.7,550.7,492.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M551,492.9l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C551.3,493,551.2,492.9,551,492.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M551.4,493.1l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C551.7,493.2,551.6,493.1,551.4,493.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M551.8,493.2l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C552.1,493.4,552,493.3,551.8,493.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M552.2,493.4l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0\n\t\t\t\t\t\t\tC552.5,493.5,552.4,493.4,552.2,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M552.7,493.6l5.3-1.8c0.2,0,0.3,0.1,0.5,0.1l-5.3,1.8C553,493.6,552.8,493.6,552.7,493.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M553.1,493.7l5.3-1.8c0.2,0,0.3,0.1,0.4,0.1l-5.3,1.8C553.4,493.8,553.3,493.7,553.1,493.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M553.6,493.8l5.3-1.8c0.2,0,0.3,0.1,0.5,0.1l-5.3,1.8C553.9,493.8,553.7,493.8,553.6,493.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M554,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C554.3,493.9,554.2,493.9,554,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M554.5,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C554.8,493.9,554.7,493.9,554.5,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M555,493.9l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C555.3,493.9,555.2,493.9,555,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M555.5,493.9l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C555.9,493.9,555.7,493.9,555.5,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M556.1,493.8l5.3-1.8c0.3,0,0.5-0.1,0.7-0.2l-5.3,1.8C556.6,493.7,556.3,493.8,556.1,493.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M556.8,493.6l5.3-1.8c0,0,0.1,0,0.1,0L556.8,493.6C556.9,493.6,556.9,493.6,556.8,493.6",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000162313597939621197340000004726270063768230530_",
                                        d: "M563.6,496.1l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.2,0.7-0.3l5.3-1.8C564.1,495.9,563.8,496,563.6,496.1z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000146459087778951772580000016529581961424921761_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000162313597939621197340000004726270063768230530_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000146459087778951772580000016529581961424921761_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M559,497.6l5.3-1.8c-0.2,0.1-0.5,0.2-0.7,0.3l-5.3,1.8C558.6,497.8,558.8,497.7,559,497.6",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000104668710927422217650000015234498523817113784_",
                                        d: "M557.6,493.3l5.3-1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.5-0.1,0.7,0c0.1,0,0.3,0.1,0.4,0.2c0.4,0.3,0.8,0.7,1,1.3l-5.3,1.8c-0.2-0.6-0.5-1.1-1-1.3\n\t\t\t\t\t\t\tc-0.1-0.1-0.3-0.2-0.4-0.2C558.1,493.3,557.8,493.3,557.6,493.3z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000153673285402916632260000015235835904128222099_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000104668710927422217650000015234498523817113784_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000153673285402916632260000015235835904128222099_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M557.6,493.3l5.3-1.8c0,0,0,0,0,0L557.6,493.3C557.6,493.3,557.6,493.3,557.6,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M557.6,493.3l5.3-1.8c0.1,0,0.1,0,0.2,0l-5.3,1.8C557.7,493.3,557.7,493.3,557.6,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M557.8,493.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C557.8,493.3,557.8,493.3,557.8,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M557.9,493.3l5.3-1.8c0,0,0.1,0,0.1,0L557.9,493.3C557.9,493.3,557.9,493.3,557.9,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M558,493.3l5.3-1.8c0,0,0.1,0,0.1,0L558,493.3C558,493.3,558,493.3,558,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M558,493.3l5.3-1.8c0,0,0,0,0.1,0L558,493.3C558.1,493.3,558.1,493.3,558,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M558.1,493.3l5.3-1.8c0,0,0,0,0.1,0L558.1,493.3C558.2,493.3,558.1,493.3,558.1,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M558.2,493.3l5.3-1.8c0,0,0,0,0.1,0L558.2,493.3C558.2,493.3,558.2,493.3,558.2,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M558.3,493.3l5.3-1.8c0,0,0,0,0.1,0L558.3,493.3C558.3,493.3,558.3,493.3,558.3,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M558.3,493.3l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L558.3,493.3C558.4,493.3,558.3,493.3,558.3,493.3\n\t\t\t\t\t\t\tC558.3,493.3,558.3,493.3,558.3,493.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M558.4,493.4l5.3-1.8c0,0,0,0,0.1,0L558.4,493.4C558.4,493.4,558.4,493.4,558.4,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M558.4,493.4l5.3-1.8c0,0,0,0,0.1,0L558.4,493.4C558.5,493.4,558.5,493.4,558.4,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M558.5,493.4l5.3-1.8c0,0,0,0,0.1,0L558.5,493.4C558.5,493.4,558.5,493.4,558.5,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M558.6,493.4l5.3-1.8c0,0,0,0,0.1,0L558.6,493.4C558.6,493.5,558.6,493.5,558.6,493.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M558.6,493.5l5.3-1.8c0,0,0,0,0.1,0L558.6,493.5C558.7,493.5,558.7,493.5,558.6,493.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M558.7,493.5l5.3-1.8c0,0,0,0,0,0L558.7,493.5C558.7,493.5,558.7,493.5,558.7,493.5",
                                        },
                                      }),
                                      _c("polyline", {
                                        staticClass: "st658",
                                        attrs: {
                                          points:
                                            "558.7,493.5 564,491.8 564,491.8 564,491.8 558.7,493.5 558.7,493.5 558.7,493.5 \t\t\t\t\t\t",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M558.7,493.5l5.3-1.8c0,0,0.1,0,0.1,0.1L558.7,493.5C558.8,493.6,558.7,493.6,558.7,493.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M558.8,493.6l5.3-1.8c0,0,0,0,0.1,0.1L558.8,493.6C558.8,493.6,558.8,493.6,558.8,493.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M558.9,493.6l5.3-1.8c0,0,0,0,0.1,0.1L558.9,493.6C558.9,493.7,558.9,493.7,558.9,493.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M558.9,493.7l5.3-1.8c0,0,0,0,0.1,0.1L558.9,493.7C559,493.7,559,493.7,558.9,493.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M559,493.8l5.3-1.8c0,0,0.1,0,0.1,0.1L559,493.8C559.1,493.8,559,493.8,559,493.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M559.1,493.8l5.3-1.8c0,0,0.1,0.1,0.1,0.1L559.1,493.8C559.1,493.9,559.1,493.9,559.1,493.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M559.2,493.9l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C559.2,494,559.2,494,559.2,493.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M559.3,494l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C559.3,494.2,559.3,494.1,559.3,494",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M559.4,494.2l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C559.6,494.6,559.5,494.4,559.4,494.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M559.7,494.8l5.3-1.8c0,0,0,0,0,0L559.7,494.8C559.7,494.9,559.7,494.9,559.7,494.8",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000084517231654846081970000004328518718239633285_",
                                        d: "M559.7,494.9l5.3-1.8\n\t\t\t\t\t\t\tc0.3,0.6,0.3,1.1,0.2,1.7c-0.1,0.5-0.4,0.9-0.8,1l-5.3,1.8c0.4-0.2,0.7-0.5,0.8-1C560,496,559.9,495.5,559.7,494.9z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000122685801732222491960000018221241352908784805_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000084517231654846081970000004328518718239633285_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000122685801732222491960000018221241352908784805_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M559.7,494.9l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C559.8,495,559.7,495,559.7,494.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M559.8,495.1l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C559.8,495.2,559.8,495.2,559.8,495.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M559.8,495.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.4,559.8,495.3,559.8,495.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M559.9,495.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.5,559.9,495.4,559.9,495.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M559.9,495.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C559.9,495.6,559.9,495.6,559.9,495.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M559.9,495.6l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.6C559.9,495.7,559.9,495.7,559.9,495.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M559.9,495.7l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.7C559.9,495.8,559.9,495.7,559.9,495.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M559.9,495.8l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.8C559.9,495.9,559.9,495.8,559.9,495.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M559.9,495.9l5.3-1.8c0,0,0,0.1,0,0.1L559.9,495.9C559.9,495.9,559.9,495.9,559.9,495.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M559.9,496l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496C559.9,496,559.9,496,559.9,496",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M559.9,496.1l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.1C559.9,496.1,559.9,496.1,559.9,496.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M559.9,496.1l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.1C559.9,496.2,559.9,496.2,559.9,496.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M559.9,496.2l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.2C559.9,496.3,559.9,496.2,559.9,496.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M559.9,496.3l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.3C559.9,496.4,559.9,496.3,559.9,496.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M559.9,496.4l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.4C559.9,496.5,559.9,496.4,559.9,496.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M559.9,496.5l5.3-1.8c0,0,0,0,0,0.1c0,0,0,0,0,0L559.9,496.5C559.9,496.6,559.9,496.6,559.9,496.5\n\t\t\t\t\t\t\tC559.9,496.5,559.9,496.5,559.9,496.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M559.9,496.6l5.3-1.8c0,0,0,0.1,0,0.1L559.9,496.6C559.8,496.6,559.9,496.6,559.9,496.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M559.8,496.7l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.7C559.8,496.7,559.8,496.7,559.8,496.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M559.8,496.8l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.8C559.8,496.8,559.8,496.8,559.8,496.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M559.8,496.8l5.3-1.8c0,0,0,0.1,0,0.1L559.8,496.8C559.7,496.9,559.8,496.9,559.8,496.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M559.7,496.9l5.3-1.8c0,0,0,0.1,0,0.1L559.7,496.9C559.7,497,559.7,497,559.7,496.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M559.7,497l5.3-1.8c0,0,0,0.1-0.1,0.1L559.7,497C559.7,497.1,559.7,497,559.7,497",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M559.6,497.1l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C559.6,497.2,559.6,497.1,559.6,497.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M559.5,497.2l5.3-1.8c-0.1,0.2-0.3,0.3-0.5,0.4l-5.3,1.8C559.2,497.5,559.4,497.4,559.5,497.2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "565.2,499.7 570.5,498 570.4,500.1 565.1,501.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "565.2,497.7 570.5,495.9 570.5,498 565.2,499.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000002369324235466255060000014154721740621522855_",
                                        d: "M547.6,465.3l5.3-1.8\n\t\t\t\t\t\t\tc0.3-0.1,0.6-0.2,0.9-0.3c1.6-0.4,3.2-0.2,5,0.3c1.8,0.6,3.5,1.6,5.1,3.1c1.6,1.5,2.9,3.2,4.1,5.2l-5.3,1.8\n\t\t\t\t\t\t\tc-1.1-2-2.5-3.7-4.1-5.2c-1.6-1.5-3.3-2.5-5.1-3.1c-1.7-0.6-3.4-0.7-5-0.3C548.2,465.2,547.9,465.2,547.6,465.3z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000010991601335330899570000012515327831327792302_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000002369324235466255060000014154721740621522855_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000010991601335330899570000012515327831327792302_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M547.6,465.3l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C547.6,465.3,547.6,465.3,547.6,465.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M547.7,465.3l5.3-1.8c0.3-0.1,0.5-0.2,0.8-0.2c0.1,0,0.2,0,0.3-0.1l-5.3,1.8c-0.1,0-0.2,0-0.3,0.1\n\t\t\t\t\t\t\tC548.2,465.2,547.9,465.2,547.7,465.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M548.8,465l5.3-1.8c0.3,0,0.5-0.1,0.8-0.1l-5.3,1.8C549.3,464.9,549,465,548.8,465",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M549.6,464.9l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C550,464.9,549.8,464.9,549.6,464.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M550.3,464.9l5.3-1.8c0.2,0,0.4,0,0.6,0l-5.3,1.8C550.7,464.9,550.5,464.9,550.3,464.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M550.9,464.9l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C551.3,464.9,551.1,464.9,550.9,464.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M551.5,465l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C551.9,465,551.7,465,551.5,465",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M552.1,465.1l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C552.5,465.2,552.3,465.1,552.1,465.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M552.7,465.2l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C553.1,465.3,552.9,465.3,552.7,465.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M553.3,465.4l5.3-1.8c0,0,0.1,0,0.1,0c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8c-0.2-0.1-0.3-0.1-0.5-0.2\n\t\t\t\t\t\t\tC553.4,465.4,553.4,465.4,553.3,465.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M553.9,465.6l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C554.3,465.7,554.1,465.6,553.9,465.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M554.5,465.8l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2L555,466C554.8,466,554.7,465.9,554.5,465.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M555,466l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C555.4,466.2,555.2,466.1,555,466",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M555.5,466.3l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C555.9,466.5,555.7,466.4,555.5,466.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M556,466.6l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.3l-5.3,1.8C556.4,466.8,556.2,466.7,556,466.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M556.5,466.9l5.3-1.8c0.2,0.1,0.3,0.2,0.5,0.4l-5.3,1.8C556.9,467.2,556.7,467,556.5,466.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M557.1,467.3l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C557.4,467.5,557.2,467.4,557.1,467.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M557.6,467.7l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.5l-5.3,1.8C558,468,557.8,467.8,557.6,467.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M558.1,468.1l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.4c0.1,0,0.1,0.1,0.2,0.1l-5.3,1.8c-0.1,0-0.1-0.1-0.2-0.1\n\t\t\t\t\t\t\tC558.4,468.4,558.3,468.3,558.1,468.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M558.7,468.7l5.3-1.8c0.2,0.2,0.5,0.5,0.7,0.7l-5.3,1.8C559.2,469.1,558.9,468.9,558.7,468.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M559.4,469.4l5.3-1.8c0.3,0.3,0.5,0.6,0.8,0.8l-5.3,1.8C559.9,469.9,559.7,469.6,559.4,469.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M560.2,470.2l5.3-1.8c0.3,0.3,0.6,0.7,0.8,1l-5.3,1.8C560.7,470.9,560.5,470.5,560.2,470.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M561,471.2l5.3-1.8c0.3,0.5,0.7,0.9,1,1.4l-5.3,1.8C561.7,472.2,561.4,471.7,561,471.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M562,472.7l5.3-1.8c0.2,0.3,0.4,0.7,0.6,1l-5.3,1.8C562.4,473.3,562.2,473,562,472.7",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "566,472.5 571.3,470.7 570.5,495.9 565.2,497.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "566,471.7 571.3,469.9 571.3,470.7 566,472.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "562.8,467.3 568.1,465.5 571.4,466.6 566.1,468.3 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "566.1,468.3 571.4,466.6 571.3,469.9 566,471.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M566.1,468.3l-0.1,3.4l0,0.8l-0.7,25.2l-0.1,2.1l-0.1,2.1l-3.3-1.1l0.1-2.1l0.1-2.1l0.3-12\n\t\t\t\t\t\tc0-1.7-0.2-3.3-0.6-4.9c-0.5-1.6-1.1-3.1-1.9-4.4c-0.8-1.3-1.8-2.5-2.9-3.5c-1.1-1-2.3-1.7-3.6-2.1c-1.3-0.4-2.5-0.5-3.7-0.2\n\t\t\t\t\t\tc-1.1,0.3-2.2,0.8-3,1.6c-0.9,0.8-1.6,1.8-2.1,3.1c-0.5,1.3-0.8,2.8-0.9,4.4s0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4\n\t\t\t\t\t\tc0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.7,0.6,3.4,0.5,4.8-0.1c0.3-0.1,0.6-0.2,0.9-0.1c0.1,0,0.3,0.1,0.4,0.2\n\t\t\t\t\t\tc0.4,0.3,0.8,0.7,1,1.3c0.3,0.6,0.3,1.1,0.2,1.7c-0.1,0.5-0.4,0.9-0.8,1c-2,0.9-4.2,0.9-6.6,0.2c-1.7-0.6-3.4-1.5-4.9-2.9\n\t\t\t\t\t\tc-1.5-1.3-2.8-2.9-3.9-4.8c-1.1-1.8-1.9-3.8-2.5-6c-0.6-2.2-0.9-4.4-0.8-6.6c0.1-2.2,0.5-4.2,1.2-6c0.7-1.8,1.7-3.2,2.9-4.3\n\t\t\t\t\t\tc1.2-1.1,2.6-1.8,4.1-2.2c1.6-0.4,3.2-0.2,5,0.3c1.8,0.6,3.5,1.6,5.1,3.1c1.6,1.5,2.9,3.2,4.1,5.2l0.1-2.2l0-0.8l0.1-3.4\n\t\t\t\t\t\tL566.1,468.3z",
                                    },
                                  }),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000002354942247218208750000000503410145361130390_",
                                        d: "M587.8,505.5l-5.3,1.8\n\t\t\t\t\t\t\tc0.1,0,0.3-0.1,0.4-0.2l5.3-1.8C588.1,505.4,587.9,505.5,587.8,505.5z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000150099889067352153020000009778269164117629066_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000002354942247218208750000000503410145361130390_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000150099889067352153020000009778269164117629066_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M582.9,507l5.3-1.8c-0.1,0.1-0.3,0.2-0.4,0.2l-5.3,1.8C582.7,507.2,582.8,507.1,582.9,507",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "579.7,497 585,495.2 584.9,497.5 579.7,499.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "576.3,495.9 581.6,494.1 585,495.2 579.7,497 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000168099220707274926710000010670436460649875877_",
                                        d: "M579.7,499.2l5.3-1.8\n\t\t\t\t\t\t\tc0,0.8,0.2,1.6,0.6,2.3s1,1.2,1.6,1.4c0.5,0.1,0.9,0.5,1.2,1l-5.3,1.8c-0.3-0.6-0.7-0.9-1.2-1c-0.6-0.2-1.2-0.7-1.6-1.4\n\t\t\t\t\t\t\tS579.6,500.1,579.7,499.2z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000005265855133241219400000006682045101463137725_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000168099220707274926710000010670436460649875877_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000005265855133241219400000006682045101463137725_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M579.7,499.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C579.7,499.3,579.7,499.3,579.7,499.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M579.7,499.4l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.5,579.7,499.4,579.7,499.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M579.7,499.5l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.6,579.7,499.6,579.7,499.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M579.7,499.7l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.8,579.7,499.7,579.7,499.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M579.7,499.8l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,499.9,579.7,499.9,579.7,499.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M579.7,500l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,500.1,579.7,500,579.7,500",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M579.7,500.1l5.3-1.8c0,0.1,0,0.1,0,0.2l-5.3,1.8C579.7,500.3,579.7,500.2,579.7,500.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M579.8,500.3l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C579.8,500.4,579.8,500.4,579.8,500.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M579.8,500.5l5.3-1.8c0,0.1,0.1,0.2,0.1,0.2l-5.3,1.8C579.9,500.7,579.8,500.6,579.8,500.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M579.9,500.8l5.3-1.8c0.1,0.3,0.2,0.5,0.4,0.8c0,0,0,0.1,0.1,0.1l-5.3,1.8c0,0,0-0.1-0.1-0.1\n\t\t\t\t\t\t\tC580.1,501.3,580,501,579.9,500.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M580.3,501.6l5.3-1.8c0.1,0.1,0.1,0.2,0.2,0.3l-5.3,1.8C580.4,501.8,580.4,501.7,580.3,501.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M580.5,501.9l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C580.6,502,580.5,501.9,580.5,501.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M580.6,502l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.7,502.1,580.7,502.1,580.6,502",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M580.7,502.2l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.8,502.2,580.8,502.2,580.7,502.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M580.8,502.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C580.9,502.3,580.9,502.3,580.8,502.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M581,502.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1L581,502.4C581,502.4,581,502.4,581,502.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M581,502.5l5.3-1.8c0,0,0.1,0,0.1,0.1L581,502.5C581.1,502.5,581.1,502.5,581,502.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M581.1,502.5l5.3-1.8c0,0,0.1,0,0.1,0.1L581.1,502.5C581.2,502.6,581.2,502.5,581.1,502.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M581.2,502.6l5.3-1.8c0,0,0.1,0,0.1,0.1L581.2,502.6C581.3,502.6,581.3,502.6,581.2,502.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M581.3,502.7l5.3-1.8c0,0,0.1,0,0.1,0.1L581.3,502.7C581.4,502.7,581.4,502.7,581.3,502.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M581.4,502.7l5.3-1.8c0,0,0.1,0,0.1,0.1l-5.3,1.8C581.5,502.7,581.5,502.7,581.4,502.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M581.5,502.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C581.6,502.8,581.6,502.8,581.5,502.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M581.6,502.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C581.7,502.8,581.7,502.8,581.6,502.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M581.8,502.9l5.3-1.8c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l-5.3,1.8C581.9,502.9,581.9,502.9,581.8,502.9\n\t\t\t\t\t\t\tC581.8,502.9,581.8,502.9,581.8,502.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M581.9,502.9l5.3-1.8c0,0,0.1,0,0.1,0L581.9,502.9C582,502.9,581.9,502.9,581.9,502.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M582,502.9l5.3-1.8c0,0,0,0,0.1,0L582,502.9C582,503,582,503,582,502.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M582.1,503l5.3-1.8c0,0,0,0,0.1,0L582.1,503C582.1,503,582.1,503,582.1,503",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M582.1,503l5.3-1.8c0,0,0,0,0.1,0L582.1,503C582.2,503,582.2,503,582.1,503",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M582.2,503l5.3-1.8c0,0,0,0,0.1,0L582.2,503C582.3,503.1,582.2,503.1,582.2,503",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M582.3,503.1l5.3-1.8c0,0,0,0,0.1,0L582.3,503.1C582.3,503.1,582.3,503.1,582.3,503.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M582.3,503.1l5.3-1.8c0,0,0,0,0.1,0.1L582.3,503.1C582.4,503.2,582.4,503.2,582.3,503.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M582.4,503.2l5.3-1.8c0,0,0,0,0.1,0.1L582.4,503.2C582.5,503.2,582.4,503.2,582.4,503.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M582.5,503.2l5.3-1.8c0,0,0,0,0.1,0.1L582.5,503.2C582.5,503.3,582.5,503.3,582.5,503.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M582.6,503.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1L582.6,503.3C582.6,503.4,582.6,503.3,582.6,503.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M582.6,503.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1L582.6,503.4C582.7,503.5,582.7,503.4,582.6,503.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M582.7,503.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C582.8,503.6,582.8,503.5,582.7,503.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M582.8,503.6l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C582.9,503.8,582.9,503.7,582.8,503.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M583,503.8l5.3-1.8c0,0,0,0.1,0.1,0.1l-5.3,1.8C583,503.9,583,503.9,583,503.8",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M579.7,497l-0.1,2.2c0,0.8,0.2,1.6,0.6,2.3s1,1.2,1.6,1.4c0.5,0.1,0.9,0.5,1.2,1\n\t\t\t\t\t\tc0.3,0.5,0.5,1.1,0.5,1.7c0,0.6-0.2,1.1-0.6,1.4c-0.4,0.3-0.8,0.4-1.2,0.2c-1.6-0.5-2.9-1.7-4-3.4c-1-1.7-1.5-3.5-1.5-5.4\n\t\t\t\t\t\tl0.1-2.5L579.7,497z",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000008838716792707577020000006731609015933970323_",
                                        d: "M583,503.9l5.3-1.8\n\t\t\t\t\t\t\tc0.3,0.5,0.5,1.1,0.5,1.7c0,0.6-0.2,1.1-0.6,1.4l-5.3,1.8c0.4-0.3,0.5-0.8,0.6-1.4C583.5,505,583.4,504.5,583,503.9z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000145026283879352087750000003303715176152285591_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000008838716792707577020000006731609015933970323_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000145026283879352087750000003303715176152285591_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M583,503.9l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C583.3,504.3,583.2,504.1,583,503.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M583.3,504.6l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C583.4,504.7,583.4,504.6,583.3,504.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M583.4,504.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.4,504.8,583.4,504.8,583.4,504.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M583.4,504.9l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.4,505,583.4,504.9,583.4,504.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M583.5,505l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.1,583.5,505,583.5,505",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M583.5,505.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.2,583.5,505.2,583.5,505.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M583.5,505.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.3,583.5,505.3,583.5,505.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M583.5,505.3l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.4,583.5,505.4,583.5,505.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M583.5,505.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.5,583.5,505.5,583.5,505.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M583.5,505.5l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0l-5.3,1.8C583.5,505.6,583.5,505.6,583.5,505.5\n\t\t\t\t\t\t\tC583.5,505.6,583.5,505.6,583.5,505.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M583.5,505.6l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.7,583.5,505.7,583.5,505.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M583.5,505.7l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C583.5,505.8,583.5,505.8,583.5,505.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M583.5,505.9l5.3-1.8c0,0,0,0.1,0,0.1L583.5,505.9C583.5,505.9,583.5,505.9,583.5,505.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M583.5,505.9l5.3-1.8c0,0,0,0.1,0,0.1L583.5,505.9C583.5,506,583.5,506,583.5,505.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M583.5,506l5.3-1.8c0,0,0,0.1,0,0.1L583.5,506C583.5,506.1,583.5,506.1,583.5,506",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M583.4,506.1l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.1C583.4,506.2,583.4,506.2,583.4,506.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M583.4,506.2l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.2C583.4,506.3,583.4,506.2,583.4,506.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M583.4,506.3l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.3C583.4,506.4,583.4,506.3,583.4,506.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M583.4,506.4l5.3-1.8c0,0,0,0.1,0,0.1L583.4,506.4C583.4,506.4,583.4,506.4,583.4,506.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M583.3,506.5l5.3-1.8c0,0,0,0.1,0,0.1L583.3,506.5C583.3,506.5,583.3,506.5,583.3,506.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M583.3,506.5l5.3-1.8c0,0,0,0.1,0,0.1L583.3,506.5C583.3,506.6,583.3,506.6,583.3,506.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M583.3,506.6l5.3-1.8c0,0,0,0.1-0.1,0.1L583.3,506.6C583.2,506.7,583.2,506.7,583.3,506.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M583.2,506.7l5.3-1.8c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C583.1,506.8,583.2,506.8,583.2,506.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M583.1,506.9l5.3-1.8c-0.1,0.1-0.1,0.1-0.2,0.2l-5.3,1.8C583,507,583.1,506.9,583.1,506.9",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "579.9,491.8 585.1,490 585.1,493.3 579.8,495.1 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "579.9,490.9 585.2,489.1 585.1,490 579.9,491.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "580.8,459.8 586.1,458.1 585.2,489.1 579.9,490.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "580.8,457.8 586.1,456.1 586.1,458.1 580.8,459.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st671",
                                    attrs: {
                                      points:
                                        "580.9,455.7 580.8,457.8 580.8,459.8 579.9,490.9 579.9,491.8 579.8,495.1 576.4,494\n\t\t\t\t\t\t576.4,490.7 576.5,489.8 577.4,458.7 577.4,456.7 577.5,454.5 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st674",
                                    attrs: {
                                      points:
                                        "580.9,455.7 586.2,453.9 586.1,456.1 580.8,457.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "577.5,454.5 582.8,452.8 586.2,453.9 580.9,455.7 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                              ]),
                              _c("g", { staticClass: "st417" }, [
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000113328961384275997610000004466838121637650566_",
                                        d: "M513,457.9l5.3-1.8\n\t\t\t\t\t\t\tc-0.1,0-0.2,0.1-0.2,0.1c-1.4,0.5-2.6,1.5-3.5,2.9c-0.7,1.1-1.2,2.5-1.5,4.1c0,0.3-0.1,0.6-0.1,0.9c0,0.3-0.1,0.6-0.1,1\n\t\t\t\t\t\t\tc0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.4,0.5,2.8,0.5,4.2,0.1\n\t\t\t\t\t\t\tc0.1,0,0.1,0,0.2-0.1l-5.3,1.8c-0.1,0-0.1,0-0.2,0.1c-1.3,0.4-2.7,0.4-4.2-0.1c-1.3-0.4-2.5-1.1-3.6-2.1\n\t\t\t\t\t\t\tc-1.1-1-2.1-2.2-2.9-3.5c-0.8-1.3-1.4-2.8-1.9-4.4c-0.5-1.6-0.7-3.2-0.6-4.9c0-0.3,0-0.7,0.1-1c0-0.3,0.1-0.6,0.1-0.9\n\t\t\t\t\t\t\tc0.3-1.6,0.8-2.9,1.5-4.1c0.9-1.4,2.1-2.4,3.5-2.9C512.8,458,512.9,457.9,513,457.9z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000128445405116303302950000011194566396625565600_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000113328961384275997610000004466838121637650566_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000128445405116303302950000011194566396625565600_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M513,457.9l5.3-1.8c-0.1,0-0.2,0.1-0.2,0.1c-1.1,0.4-2,1.1-2.8,2.1l-5.3,1.8c0.8-1,1.7-1.6,2.8-2.1\n\t\t\t\t\t\t\tC512.8,458,512.9,457.9,513,457.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M509.9,460.1l5.3-1.8c-0.2,0.2-0.4,0.5-0.5,0.7l-5.3,1.8C509.5,460.5,509.7,460.3,509.9,460.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M509.4,460.8l5.3-1.8c0,0-0.1,0.1-0.1,0.1c-0.1,0.1-0.2,0.3-0.2,0.4l-5.3,1.8c0.1-0.1,0.2-0.3,0.2-0.4\n\t\t\t\t\t\t\tC509.3,460.9,509.3,460.8,509.4,460.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M509,461.3l5.3-1.8c-0.1,0.2-0.2,0.4-0.3,0.6l-5.3,1.8C508.8,461.7,508.9,461.5,509,461.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M508.7,461.9l5.3-1.8c-0.1,0.2-0.2,0.3-0.2,0.5l-5.3,1.8C508.6,462.2,508.6,462.1,508.7,461.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M508.5,462.4l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C508.4,462.7,508.4,462.6,508.5,462.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M508.3,462.9l5.3-1.8c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8C508.2,463.3,508.2,463.1,508.3,462.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M508.1,463.4l5.3-1.8c-0.1,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C508,463.8,508.1,463.6,508.1,463.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M508,463.9l5.3-1.8c0,0.2-0.1,0.3-0.1,0.5l-5.3,1.8C507.9,464.3,508,464.1,508,463.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M507.9,464.4l5.3-1.8c0,0.2-0.1,0.4-0.1,0.5l-5.3,1.8C507.8,464.8,507.8,464.6,507.9,464.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M507.8,465l5.3-1.8c0,0,0,0,0,0c0,0.1,0,0.2,0,0.3l-5.3,1.8C507.7,465.2,507.7,465.1,507.8,465\n\t\t\t\t\t\t\tC507.8,465,507.8,465,507.8,465",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M507.7,465.3l5.3-1.8c0,0.2,0,0.3-0.1,0.5l-5.3,1.8C507.7,465.6,507.7,465.5,507.7,465.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M507.7,465.8l5.3-1.8c0,0,0,0.1,0,0.1c0,0.1,0,0.3,0,0.5l-5.3,1.8c0-0.2,0-0.3,0-0.5\n\t\t\t\t\t\t\tC507.7,465.9,507.7,465.8,507.7,465.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M507.6,466.4l5.3-1.8c0,0.2,0,0.3,0,0.5l-5.3,1.8C507.6,466.7,507.6,466.5,507.6,466.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M507.6,466.8l5.3-1.8c0,0,0,0,0,0c0,0.2,0,0.3,0,0.5l-5.3,1.8C507.6,467.2,507.6,467.1,507.6,466.8\n\t\t\t\t\t\t\tC507.6,466.9,507.6,466.9,507.6,466.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M507.6,467.4l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C507.6,467.8,507.6,467.6,507.6,467.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M507.6,468l5.3-1.8c0,0.2,0,0.4,0,0.6l-5.3,1.8C507.6,468.3,507.6,468.1,507.6,468",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M507.6,468.5l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C507.7,468.9,507.6,468.7,507.6,468.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M507.7,469.1l5.3-1.8c0,0.2,0,0.4,0.1,0.6l-5.3,1.8C507.7,469.5,507.7,469.3,507.7,469.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M507.8,469.7l5.3-1.8c0,0.2,0.1,0.4,0.1,0.6l-5.3,1.8C507.8,470.1,507.8,469.9,507.8,469.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M507.9,470.3l5.3-1.8c0,0.2,0.1,0.5,0.1,0.7L508,471C508,470.8,507.9,470.6,507.9,470.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M508,471l5.3-1.8c0.1,0.2,0.1,0.5,0.2,0.7c0,0,0,0.1,0,0.1l-5.3,1.8c0,0,0-0.1,0-0.1\n\t\t\t\t\t\t\tC508.1,471.5,508.1,471.3,508,471",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M508.2,471.8l5.3-1.8c0.1,0.4,0.2,0.8,0.4,1.2l-5.3,1.8C508.5,472.7,508.3,472.2,508.2,471.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M508.6,473l5.3-1.8c0.4,1.1,0.9,2.2,1.5,3.1c0.1,0.1,0.2,0.3,0.2,0.4l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.2-0.3-0.2-0.4C509.5,475.2,509,474.2,508.6,473",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M510.3,476.6l5.3-1.8c0.2,0.4,0.5,0.7,0.7,1l-5.3,1.8C510.8,477.2,510.5,476.9,510.3,476.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M511,477.6l5.3-1.8c0.2,0.2,0.4,0.5,0.6,0.7l-5.3,1.8C511.4,478.1,511.2,477.8,511,477.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M511.6,478.3l5.3-1.8c0.2,0.2,0.4,0.4,0.5,0.6l-5.3,1.8C512,478.7,511.8,478.5,511.6,478.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M512.1,478.9l5.3-1.8c0.2,0.2,0.3,0.3,0.5,0.5l-5.3,1.8C512.5,479.2,512.3,479.1,512.1,478.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M512.7,479.4l5.3-1.8c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.1,0.1,0.2,0.2l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.1-0.1-0.2-0.2C512.9,479.6,512.8,479.5,512.7,479.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M513.1,479.8l5.3-1.8c0.1,0.1,0.3,0.2,0.4,0.3l-5.3,1.8C513.4,480.1,513.3,480,513.1,479.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M513.5,480.2l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C513.8,480.4,513.6,480.3,513.5,480.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M513.9,480.5l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.3l-5.3,1.8C514.1,480.6,514,480.5,513.9,480.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M514.3,480.7l5.3-1.8c0.1,0.1,0.2,0.2,0.4,0.2l-5.3,1.8C514.5,480.9,514.4,480.8,514.3,480.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M514.6,480.9l5.3-1.8c0.1,0.1,0.2,0.1,0.4,0.2l-5.3,1.8C514.9,481.1,514.8,481,514.6,480.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M515,481.2l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C515.3,481.3,515.1,481.2,515,481.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M515.4,481.3l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C515.6,481.5,515.5,481.4,515.4,481.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M515.8,481.5l5.3-1.8c0.1,0.1,0.3,0.1,0.4,0.2l-5.3,1.8C516.1,481.6,515.9,481.6,515.8,481.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M516.2,481.7l5.3-1.8c0.1,0,0.2,0.1,0.4,0.1c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0\n\t\t\t\t\t\t\tC516.4,481.8,516.3,481.7,516.2,481.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M516.6,481.8l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1L517,482C516.9,481.9,516.8,481.9,516.6,481.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M517,482l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C517.3,482,517.2,482,517,482",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M517.5,482.1l5.3-1.8c0.1,0,0.3,0.1,0.4,0.1l-5.3,1.8C517.8,482.1,517.6,482.1,517.5,482.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M517.9,482.1l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C518.2,482.2,518.1,482.1,517.9,482.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M518.4,482.2l5.3-1.8c0.2,0,0.3,0,0.5,0l-5.3,1.8C518.7,482.2,518.5,482.2,518.4,482.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M518.9,482.2l5.3-1.8c0.2,0,0.4,0,0.5,0l-5.3,1.8C519.2,482.2,519,482.2,518.9,482.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M519.4,482.2l5.3-1.8c0.2,0,0.4,0,0.6-0.1l-5.3,1.8C519.8,482.1,519.6,482.1,519.4,482.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M520,482.1l5.3-1.8c0.2,0,0.5-0.1,0.7-0.2c0,0,0.1,0,0.1,0l-5.3,1.8c0,0-0.1,0-0.1,0\n\t\t\t\t\t\t\tC520.5,482,520.3,482,520,482.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M520.8,481.9l5.3-1.8c0,0,0.1,0,0.1,0L520.8,481.9C520.9,481.9,520.9,481.9,520.8,481.9",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "510.4,463.3 515.7,461.5 517.3,462 512.1,463.8 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "512.1,463.8 517.3,462 517.7,462.2 512.4,463.9 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000139291023086495528140000017100630031508840872_",
                                        d: "M511.4,453.7l5.3-1.8\n\t\t\t\t\t\t\tc1.9-0.6,3.8-0.6,5.9,0.1l-5.3,1.8C515.3,453.1,513.3,453.1,511.4,453.7z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000020359518521689053870000002437204660727012747_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000139291023086495528140000017100630031508840872_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000020359518521689053870000002437204660727012747_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M511.4,453.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C511.5,453.7,511.5,453.7,511.4,453.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M511.6,453.6l5.3-1.8c0.3-0.1,0.7-0.2,1-0.3l-5.3,1.8C512.2,453.4,511.9,453.5,511.6,453.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M512.6,453.4l5.3-1.8c0.3-0.1,0.5-0.1,0.8-0.1l-5.3,1.8C513.1,453.3,512.9,453.3,512.6,453.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M513.4,453.3l5.3-1.8c0.2,0,0.5,0,0.7,0l-5.3,1.8C513.9,453.2,513.7,453.2,513.4,453.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M514.1,453.2l5.3-1.8c0.2,0,0.4,0,0.7,0l-5.3,1.8C514.6,453.2,514.4,453.2,514.1,453.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M514.8,453.3l5.3-1.8c0.2,0,0.4,0,0.6,0.1l-5.3,1.8C515.2,453.3,515,453.3,514.8,453.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M515.4,453.3l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C515.8,453.4,515.6,453.3,515.4,453.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M516,453.4l5.3-1.8c0.2,0,0.4,0.1,0.6,0.1l-5.3,1.8C516.4,453.5,516.2,453.5,516,453.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M516.6,453.6l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C517,453.7,516.8,453.6,516.6,453.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M517.2,453.7l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C517.3,453.8,517.3,453.7,517.2,453.7",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000042725338237357358330000006146199930772278955_",
                                        d: "M525.9,476.8l5.3-1.8\n\t\t\t\t\t\t\tc0.1,0,0.2,0,0.2-0.1c0.2,0,0.4,0,0.6,0.1c0.2,0.1,0.5,0.2,0.7,0.4l-5.3,1.8c-0.2-0.2-0.5-0.4-0.7-0.4\n\t\t\t\t\t\t\tc-0.2-0.1-0.4-0.1-0.6-0.1C526.1,476.8,526,476.8,525.9,476.8z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000092447991781220480970000003420026174827265936_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000042725338237357358330000006146199930772278955_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000092447991781220480970000003420026174827265936_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M525.9,476.8l5.3-1.8c0,0,0,0,0,0L525.9,476.8C525.9,476.8,525.9,476.8,525.9,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M525.9,476.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C526,476.8,526,476.8,525.9,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M526.1,476.8l5.3-1.8c0,0,0.1,0,0.1,0c0,0,0,0,0.1,0l-5.3,1.8C526.2,476.8,526.2,476.8,526.1,476.8\n\t\t\t\t\t\t\tC526.1,476.8,526.1,476.8,526.1,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M526.2,476.8l5.3-1.8c0,0,0.1,0,0.1,0l-5.3,1.8C526.3,476.8,526.2,476.8,526.2,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M526.3,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.3,476.8C526.4,476.8,526.4,476.8,526.3,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M526.4,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.4,476.8C526.5,476.8,526.4,476.8,526.4,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M526.5,476.8l5.3-1.8c0,0,0.1,0,0.1,0L526.5,476.8C526.6,476.8,526.5,476.8,526.5,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M526.6,476.8l5.3-1.8c0,0,0,0,0.1,0L526.6,476.8C526.6,476.8,526.6,476.8,526.6,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M526.7,476.8l5.3-1.8c0,0,0,0,0.1,0L526.7,476.8C526.7,476.8,526.7,476.8,526.7,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M526.7,476.8l5.3-1.8c0,0,0,0,0,0c0,0,0,0,0.1,0L526.7,476.8C526.8,476.8,526.8,476.8,526.7,476.8\n\t\t\t\t\t\t\tC526.7,476.8,526.7,476.8,526.7,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M526.8,476.8l5.3-1.8c0,0,0,0,0.1,0L526.8,476.8C526.8,476.9,526.8,476.9,526.8,476.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M526.9,476.9l5.3-1.8c0,0,0,0,0.1,0L526.9,476.9C526.9,476.9,526.9,476.9,526.9,476.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M526.9,476.9l5.3-1.8c0,0,0,0,0.1,0L526.9,476.9C527,476.9,527,476.9,526.9,476.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M527,476.9l5.3-1.8c0,0,0,0,0.1,0L527,476.9C527,477,527,477,527,476.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M527.1,477l5.3-1.8c0,0,0,0,0.1,0L527.1,477C527.1,477,527.1,477,527.1,477",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M527.1,477l5.3-1.8c0,0,0,0,0.1,0.1L527.1,477C527.2,477.1,527.2,477,527.1,477",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M527.2,477.1l5.3-1.8c0,0,0.1,0,0.1,0.1L527.2,477.1C527.3,477.1,527.2,477.1,527.2,477.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M527.3,477.1l5.3-1.8c0,0,0.1,0,0.1,0.1L527.3,477.1C527.3,477.2,527.3,477.2,527.3,477.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M527.4,477.2l5.3-1.8c0,0,0,0,0.1,0.1L527.4,477.2C527.4,477.2,527.4,477.2,527.4,477.2",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000111172380530580441230000011070782546736905619_",
                                        d: "M527.7,484.4l-5.3,1.8\n\t\t\t\t\t\t\tc1.7-0.6,3.1-1.6,4.3-3.2c0.6-0.7,1.1-1.6,1.5-2.6c0.2-0.5,0.2-1,0.1-1.6c-0.2-0.6-0.4-1.1-0.9-1.5l5.3-1.8\n\t\t\t\t\t\t\tc0.4,0.4,0.7,0.9,0.9,1.5c0.2,0.6,0.1,1.2-0.1,1.6c-0.5,1-1,1.9-1.5,2.6C530.8,482.8,529.3,483.8,527.7,484.4z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000129187038480459213060000005934990463279750559_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000111172380530580441230000011070782546736905619_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000129187038480459213060000005934990463279750559_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M527.4,477.3l5.3-1.8c0,0,0,0,0,0L527.4,477.3C527.5,477.3,527.5,477.3,527.4,477.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M527.5,477.3l5.3-1.8c0,0,0.1,0.1,0.1,0.1L527.5,477.3C527.5,477.4,527.5,477.3,527.5,477.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M527.6,477.4l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C527.6,477.5,527.6,477.4,527.6,477.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M527.7,477.5l5.3-1.8c0,0,0.1,0.1,0.1,0.1l-5.3,1.8C527.7,477.6,527.7,477.5,527.7,477.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M527.8,477.6l5.3-1.8c0,0.1,0.1,0.1,0.1,0.2l-5.3,1.8C527.9,477.7,527.8,477.7,527.8,477.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M527.9,477.8l5.3-1.8c0.1,0.2,0.2,0.4,0.3,0.6l-5.3,1.8C528.1,478.2,528,478,527.9,477.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M528.2,478.4l5.3-1.8c0,0.1,0,0.1,0.1,0.2l-5.3,1.8C528.2,478.5,528.2,478.5,528.2,478.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M528.3,478.6l5.3-1.8c0,0,0,0.1,0,0.1c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1\n\t\t\t\t\t\t\tC528.3,478.7,528.3,478.7,528.3,478.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M528.3,478.8l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.3,478.9,528.3,478.9,528.3,478.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M528.3,479l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479,528.3,479,528.3,479",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M528.4,479.1l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479.2,528.4,479.1,528.4,479.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M528.4,479.2l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C528.4,479.3,528.4,479.2,528.4,479.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M528.4,479.3l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.3C528.4,479.4,528.4,479.3,528.4,479.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M528.4,479.4l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.4C528.4,479.5,528.4,479.4,528.4,479.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M528.4,479.5l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.5C528.4,479.6,528.4,479.5,528.4,479.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M528.4,479.6l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.6C528.4,479.6,528.4,479.6,528.4,479.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M528.4,479.7l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.7C528.4,479.7,528.4,479.7,528.4,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M528.4,479.7l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.7C528.4,479.8,528.4,479.8,528.4,479.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M528.4,479.8l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.8C528.4,479.9,528.4,479.9,528.4,479.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M528.4,479.9l5.3-1.8c0,0,0,0.1,0,0.1L528.4,479.9C528.3,480,528.3,479.9,528.4,479.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M528.3,480l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480C528.3,480.1,528.3,480,528.3,480",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M528.3,480.1l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.1C528.3,480.1,528.3,480.1,528.3,480.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M528.3,480.2l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.2C528.3,480.2,528.3,480.2,528.3,480.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M528.3,480.3l5.3-1.8c0,0,0,0.1,0,0.1L528.3,480.3C528.2,480.3,528.3,480.3,528.3,480.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M528.2,480.3l5.3-1.8c0,0,0,0,0,0c-0.1,0.2-0.1,0.3-0.2,0.5l-5.3,1.8\n\t\t\t\t\t\t\tC528.1,480.7,528.1,480.5,528.2,480.3C528.2,480.4,528.2,480.4,528.2,480.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M528,480.9l5.3-1.8c-0.1,0.3-0.3,0.5-0.4,0.8l-5.3,1.8C527.7,481.4,527.9,481.1,528,480.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M527.6,481.7l5.3-1.8c-0.1,0.3-0.3,0.5-0.5,0.8l-5.3,1.8C527.3,482.2,527.4,481.9,527.6,481.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M527.1,482.4l5.3-1.8c-0.1,0.2-0.3,0.4-0.4,0.6c-0.1,0.1-0.2,0.2-0.3,0.3l-5.3,1.8\n\t\t\t\t\t\t\tc0.1-0.1,0.2-0.2,0.3-0.3C526.8,482.8,527,482.6,527.1,482.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M526.4,483.3l5.3-1.8c-1.2,1.4-2.5,2.3-4,2.8l-5.3,1.8C523.9,485.6,525.3,484.7,526.4,483.3",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                                _c("g", [
                                  _c("polygon", {
                                    staticClass: "st655",
                                    attrs: {
                                      points:
                                        "512.4,463.9 517.7,462.2 530.9,466.5 525.6,468.2 \t\t\t\t\t",
                                    },
                                  }),
                                ]),
                                _c("g", [
                                  _c("path", {
                                    staticClass: "st671",
                                    attrs: {
                                      d: "M517.4,453.8c1.6,0.5,3,1.3,4.4,2.5c1.4,1.1,2.6,2.5,3.7,4c1.1,1.5,2,3.3,2.7,5.2\n\t\t\t\t\t\tc0.7,1.9,1.2,3.9,1.3,5.9c0.1,0.6-0.1,1.1-0.3,1.5c-0.3,0.4-0.6,0.6-1.1,0.5c-1-0.3-1.8-0.6-2.6-0.8c-0.8-0.2-1.6-0.5-2.6-0.8\n\t\t\t\t\t\tc-1-0.3-1.9-0.6-2.9-1l-7.6-2.5l-2-0.6l0.1-4.4l1.7,0.5l0.4,0.1l13.2,4.3c-0.6-2.4-1.7-4.6-3.2-6.5c-1.5-1.9-3.2-3.1-5.2-3.8\n\t\t\t\t\t\tc-1.6-0.5-3.1-0.5-4.5,0c-1.4,0.5-2.6,1.5-3.5,2.9c-0.7,1.1-1.2,2.5-1.5,4.1c0,0.3-0.1,0.6-0.1,0.9c0,0.3-0.1,0.6-0.1,1\n\t\t\t\t\t\tc0,1.7,0.2,3.3,0.6,4.9c0.5,1.6,1.1,3.1,1.9,4.4c0.8,1.3,1.8,2.5,2.9,3.5c1.1,1,2.3,1.7,3.6,2.1c1.4,0.5,2.8,0.5,4.2,0.1\n\t\t\t\t\t\tc1.3-0.4,2.5-1.2,3.4-2.4c0.2-0.3,0.4-0.6,0.6-0.9c0.2-0.3,0.4-0.7,0.5-1c0.2-0.5,0.5-0.7,1-0.8c0.2,0,0.4,0,0.6,0.1\n\t\t\t\t\t\tc0.2,0.1,0.5,0.2,0.7,0.4c0.4,0.4,0.7,0.9,0.9,1.5c0.2,0.6,0.1,1.2-0.1,1.6c-0.5,1-1,1.9-1.5,2.6c-1.3,1.6-2.8,2.7-4.6,3.2\n\t\t\t\t\t\tc-1.8,0.5-3.7,0.5-5.7-0.2c-1.7-0.6-3.4-1.5-4.9-2.9c-1.5-1.3-2.8-2.9-3.9-4.8c-1.1-1.8-1.9-3.8-2.5-6\n\t\t\t\t\t\tc-0.6-2.2-0.9-4.4-0.8-6.6c0-0.9,0.1-1.7,0.2-2.6c0.2-1.1,0.4-2,0.7-3c0.3-0.9,0.7-1.7,1.2-2.5c1.2-2,2.8-3.3,4.7-4\n\t\t\t\t\t\tC513.1,453.1,515.2,453.1,517.4,453.8z",
                                    },
                                  }),
                                ]),
                                _c("g", { staticClass: "st417" }, [
                                  _c("defs", [
                                    _c("path", {
                                      staticClass: "st417",
                                      attrs: {
                                        id: "SVGID_00000057111293615324530660000013253676923883689135_",
                                        d: "M533.8,471.5l-5.3,1.8\n\t\t\t\t\t\t\tc0.2-0.1,0.4-0.2,0.6-0.5c0.3-0.4,0.4-0.9,0.3-1.5c-0.2-2-0.6-4-1.3-5.9c-0.7-1.9-1.6-3.6-2.7-5.2c-1.1-1.5-2.3-2.9-3.7-4\n\t\t\t\t\t\t\tc-1.4-1.1-2.9-1.9-4.4-2.5l5.3-1.8c1.6,0.5,3,1.3,4.4,2.5c1.4,1.1,2.6,2.5,3.7,4c1.1,1.5,2,3.3,2.7,5.2\n\t\t\t\t\t\t\tc0.7,1.9,1.2,3.9,1.3,5.9c0.1,0.6-0.1,1.1-0.3,1.5C534.2,471.3,534,471.4,533.8,471.5z",
                                      },
                                    }),
                                  ]),
                                  _c(
                                    "clipPath",
                                    {
                                      attrs: {
                                        id: "SVGID_00000125595634162739010630000003208118875178097824_",
                                      },
                                    },
                                    [
                                      _c("use", {
                                        staticStyle: { overflow: "visible" },
                                        attrs: {
                                          "xlink:href":
                                            "#SVGID_00000057111293615324530660000013253676923883689135_",
                                        },
                                      }),
                                    ]
                                  ),
                                  _c(
                                    "g",
                                    {
                                      staticStyle: {
                                        "clip-path":
                                          "url(#SVGID_00000125595634162739010630000003208118875178097824_)",
                                        "enable-background": "new",
                                      },
                                    },
                                    [
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M517.4,453.8l5.3-1.8c0.2,0.1,0.3,0.1,0.5,0.2l-5.3,1.8C517.7,453.9,517.5,453.8,517.4,453.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M517.8,453.9l5.3-1.8c0.2,0.1,0.4,0.1,0.6,0.2l-5.3,1.8C518.2,454.1,518,454,517.8,453.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M518.4,454.2l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.2l-5.3,1.8C518.8,454.3,518.6,454.2,518.4,454.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M518.9,454.4l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C519.3,454.6,519.1,454.5,518.9,454.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M519.5,454.7l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3L520,455C519.8,454.9,519.7,454.8,519.5,454.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M520,455l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.3l-5.3,1.8C520.4,455.2,520.2,455.1,520,455",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M520.5,455.3l5.3-1.8c0.2,0.1,0.4,0.2,0.5,0.4l-5.3,1.8C520.9,455.6,520.7,455.4,520.5,455.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M521.1,455.7l5.3-1.8c0.2,0.1,0.4,0.3,0.5,0.4l-5.3,1.8C521.4,456,521.3,455.8,521.1,455.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M521.6,456.1l5.3-1.8c0.1,0,0.1,0.1,0.2,0.1c0.1,0.1,0.3,0.2,0.4,0.4l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.1-0.3-0.3-0.4-0.4C521.7,456.2,521.7,456.1,521.6,456.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M522.2,456.6l5.3-1.8c0.2,0.2,0.4,0.4,0.6,0.6l-5.3,1.8C522.6,457,522.4,456.8,522.2,456.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M522.9,457.2l5.3-1.8c0.2,0.2,0.4,0.4,0.7,0.7l-5.3,1.8C523.3,457.6,523.1,457.4,522.9,457.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M523.5,457.8l5.3-1.8c0.2,0.2,0.5,0.5,0.7,0.8l-5.3,1.8C524,458.3,523.7,458.1,523.5,457.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M524.2,458.6l5.3-1.8c0.3,0.3,0.5,0.6,0.8,0.9l-5.3,1.8C524.7,459.2,524.5,458.9,524.2,458.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M525,459.6l5.3-1.8c0.2,0.2,0.3,0.4,0.5,0.7c0.2,0.2,0.3,0.5,0.5,0.7l-5.3,1.8\n\t\t\t\t\t\t\tc-0.1-0.2-0.3-0.5-0.5-0.7C525.3,460,525.1,459.8,525,459.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st667",
                                        attrs: {
                                          d: "M525.9,460.9l5.3-1.8c0.9,1.4,1.6,2.9,2.2,4.5c0,0.1,0.1,0.2,0.1,0.2l-5.3,1.8c0-0.1-0.1-0.2-0.1-0.2\n\t\t\t\t\t\t\tC527.5,463.8,526.8,462.3,525.9,460.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st666",
                                        attrs: {
                                          d: "M528.2,465.7l5.3-1.8c0.2,0.5,0.3,0.9,0.5,1.4l-5.3,1.8C528.5,466.6,528.4,466.1,528.2,465.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st665",
                                        attrs: {
                                          d: "M528.7,467.1l5.3-1.8c0.1,0.4,0.2,0.7,0.3,1.1l-5.3,1.8C528.9,467.8,528.8,467.4,528.7,467.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st664",
                                        attrs: {
                                          d: "M528.9,468.1l5.3-1.8c0.1,0.3,0.1,0.6,0.2,0.9l-5.3,1.8C529.1,468.8,529,468.5,528.9,468.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st663",
                                        attrs: {
                                          d: "M529.1,469.1l5.3-1.8c0.1,0.3,0.1,0.6,0.1,0.9l-5.3,1.8C529.3,469.7,529.2,469.4,529.1,469.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st662",
                                        attrs: {
                                          d: "M529.3,470l5.3-1.8c0,0.3,0.1,0.6,0.1,0.8l-5.3,1.8C529.4,470.5,529.3,470.3,529.3,470",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st661",
                                        attrs: {
                                          d: "M529.4,470.8l5.3-1.8c0,0.2,0,0.3,0,0.5c0,0,0,0,0,0.1l-5.3,1.8c0,0,0,0,0-0.1\n\t\t\t\t\t\t\tC529.4,471.1,529.4,471,529.4,470.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st660",
                                        attrs: {
                                          d: "M529.5,471.4l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C529.5,471.5,529.5,471.4,529.5,471.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st659",
                                        attrs: {
                                          d: "M529.5,471.5l5.3-1.8c0,0,0,0.1,0,0.1l-5.3,1.8C529.5,471.6,529.5,471.5,529.5,471.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st658",
                                        attrs: {
                                          d: "M529.5,471.6l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.6C529.5,471.7,529.5,471.6,529.5,471.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st657",
                                        attrs: {
                                          d: "M529.5,471.7l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.7C529.5,471.8,529.5,471.7,529.5,471.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st656",
                                        attrs: {
                                          d: "M529.5,471.8l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.8C529.5,471.9,529.5,471.8,529.5,471.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st655",
                                        attrs: {
                                          d: "M529.5,471.9l5.3-1.8c0,0,0,0.1,0,0.1L529.5,471.9C529.5,471.9,529.5,471.9,529.5,471.9",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st654",
                                        attrs: {
                                          d: "M529.4,472l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472C529.4,472,529.4,472,529.4,472",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st653",
                                        attrs: {
                                          d: "M529.4,472l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472C529.4,472.1,529.4,472.1,529.4,472",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st652",
                                        attrs: {
                                          d: "M529.4,472.1l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.1C529.4,472.2,529.4,472.2,529.4,472.1",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st651",
                                        attrs: {
                                          d: "M529.4,472.2l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.2C529.4,472.3,529.4,472.2,529.4,472.2",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st650",
                                        attrs: {
                                          d: "M529.4,472.3l5.3-1.8c0,0,0,0.1,0,0.1L529.4,472.3C529.4,472.4,529.4,472.3,529.4,472.3",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st649",
                                        attrs: {
                                          d: "M529.3,472.4l5.3-1.8c0,0,0,0.1,0,0.1L529.3,472.4C529.3,472.4,529.3,472.4,529.3,472.4",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st648",
                                        attrs: {
                                          d: "M529.3,472.5l5.3-1.8c0,0,0,0.1,0,0.1L529.3,472.5C529.3,472.5,529.3,472.5,529.3,472.5",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st647",
                                        attrs: {
                                          d: "M529.3,472.6l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C529.2,472.6,529.3,472.6,529.3,472.6",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st646",
                                        attrs: {
                                          d: "M529.2,472.7l5.3-1.8c0,0,0,0.1-0.1,0.1l-5.3,1.8C529.2,472.7,529.2,472.7,529.2,472.7",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st645",
                                        attrs: {
                                          d: "M529.1,472.8l5.3-1.8c0,0,0,0,0,0c0,0-0.1,0.1-0.1,0.1l-5.3,1.8C529.1,472.9,529.1,472.9,529.1,472.8\n\t\t\t\t\t\t\tC529.1,472.8,529.1,472.8,529.1,472.8",
                                        },
                                      }),
                                      _c("path", {
                                        staticClass: "st644",
                                        attrs: {
                                          d: "M529,472.9l5.3-1.8c-0.1,0.2-0.3,0.3-0.5,0.4l-5.3,1.8C528.7,473.2,528.9,473.1,529,472.9",
                                        },
                                      }),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                        ]),
                        _c("g", [
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M175.1,962.1c1.7,0.1,3.4,0.1,5.2,0.4c2.4,0.1,10.8,0.8,16,6.9c2.2,2.4,5.4,7.6,5.4,16.1\n\t\tc0,1.8-0.1,4.9-1.1,9.1c-0.9,3.4-2.7,10-9.8,15.2c-8.1,5.8-17.1,5.7-20.5,5.7c-3.3,0-6.5-0.3-9.9-0.6l-4.8-15.2\n\t\tc3.5,0.4,7.1,0.8,10.6,0.8c0.7,0,3.7,0,6.1-0.7c5.9-1.7,10.6-6.8,10.6-13c0-1-0.1-3.5-1.4-5.7c-2.4-4-6.4-4.4-15.7-4.1h-12.2\n\t\tc-0.9,15.8-1.8,31.7-2.4,47.4c-0.4,9.6-0.7,19.1-0.8,28.6H130c0.6-4.7,1.1-9.5,1.4-14.1c0.6-7.1,0.8-14.1,1.1-21.3\n\t\tc0.6-8.7,1-17.3,1.3-26c0.3-9.9,0.4-19.6,0.7-29.5L175.1,962.1L175.1,962.1z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st404",
                            attrs: {
                              d: "M588,979.9c-13-2.7-17.3-3.5-30.4-4.1c-2.1,0.1-9.1,0.3-15.3,2.7c-7.4,2.8-18.9,11.7-18.9,31.3\n\t\tc0,3.5,0.4,13.4,7.2,21.2c1.4,1.6,4.8,5.1,10.4,7.1c4.1,1.4,7.9,1.6,12.3,1.8c10-0.4,12-0.9,17.8-2.2l1-21.6h-15.2l0.8-15.4h33.9\n\t\tc-0.9,11.3-2,22.5-2.4,33.8l-0.4,17.5c-2.4,0.4-20.8,3.4-34.6,3.4c-4.1,0-6.6-0.1-14-1c-10.2-2.2-17.3-4.1-24.7-12\n\t\tc-4.3-4.5-11.3-14.1-11.3-30c0-4.7,0.7-9.1,1.3-13.6c0.4-2.1,0.9-4,1.4-6.1c0.6-1.4,0.9-2.8,1.4-4.3c2-4.5,3.1-6.6,4.4-8.7\n\t\tc8.6-13.4,21.8-16.4,26.9-17.7c3.8-0.8,9.3-2,18.7-2c6.9,0,14.1,0.6,28.1,2.2L588,979.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M256.6,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7\n\t\tc-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7h-21.2c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12\n\t\tc-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6\n\t\tc-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3H207c0.9-7.4,1.5-14.8,2-22.3\n\t\tc0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L256.6,984L256.6,984z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M306.3,983.9c-1,11.7-2,23.5-2.7,35.3c-0.7,11.2-1.3,22.6-1.9,33.8h-19.3c1.3-11.9,2.4-23.7,3.2-35.6\n\t\tc0.6-11.2,0.9-22.3,1.3-33.6L306.3,983.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M385.4,996.8c-9.3-1.6-11.9-2.1-21.3-2.6c-10.9,0.3-19.9,1-26.7,8.1c-2.7,2.9-7.3,9-7.3,18.1\n\t\tc0,9.5,5.6,17.1,17.2,20.3c2.9,0.8,5.6,1.2,11.8,1.6c10.9,0,13.6-0.4,23.8-2.7l-3.2,13.5c-5.4,0.6-7.9,1-17.5,1.3\n\t\tc-1.9,0-3.9,0.1-5.9,0.1c-2.5,0-5.4-0.1-10.5-0.6c-6.6-1.2-12-2.1-17.7-5.2c-9.9-5.4-13.3-12.8-14.4-15.9c-1.4-3.9-1.7-8.3-1.9-9.5\n\t\tc0-8.5,0.6-10,1.9-14.5c1.6-4.2,2.7-6.4,3.9-8.2c4.5-7.1,12.6-13.2,22.2-15.9c4.4-1.2,8-1.6,12.6-2.1c10.4-0.4,14.4-0.7,32,1.2\n\t\tL385.4,996.8z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M459,983.7l-0.5,12.4c-7.8-0.4-15.5-0.7-23.4-0.7c-7.6,0-15.3,0.2-23,0.4l-0.7,15.7l40.5-0.3l-0.7,12.5\n\t\tc-7.2-0.2-14.4-0.5-21.5-0.5c-6.4,0-12.6,0.1-18.9,0.3l-1,17.6c8.8,0.1,17.7,0.3,26.4,0.1c6.8-0.2,13.4-0.5,20.2-0.9v12.5h-66.4\n\t\tc0.5-3.9,1-7.6,1.4-11.5c0.5-5.7,0.7-11.5,1-17.1c0.5-7.8,1-15.7,1.3-23.5c0.3-5.7,0.3-11.4,0.4-17.1L459,983.7L459,983.7z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M625.4,983.9c-0.9,6.2-1.7,12.5-2.3,18.8c-0.7,8.3-1.3,16.7-1.6,25.1c0.1,3.9,0.5,5.4,1.6,7.2\n\t\tc4.4,7.4,16.9,7.4,19.1,7.4c3.2,0,15.8-0.1,20.3-8.4c1.3-2.4,1.5-4.9,1.6-5.7c0.6-9.8,1.4-19.7,1.7-29.4c0.1-5,0.1-10.1,0.3-15.1\n\t\tl19.5,0.1c-0.7,6.4-1.5,12.8-1.9,19.5c-0.5,5.9-0.6,12-1,17.9c-0.3,3.9-0.6,7.8-1,11.7c-0.1,0.3-1,4.1-2.1,6.4\n\t\tc-1.6,3.4-5.7,10-17.2,13c-2.4,0.7-5.6,1.2-8,1.5c-4.3,0.4-8.4,0.7-12.5,0.7c-4,0-7.9-0.3-11.9-0.7c-1.4-0.2-2.7-0.4-4.2-0.7\n\t\tc-6.2-1.1-11.2-2.9-15.5-6.6c-1.3-1.1-3.7-3.2-5.3-6.5c-1.1-2.6-1.5-6.7-1.5-7.2c0-2.6,0-5.4,0.1-8c0.4-4.7,1-9.5,1.3-14.3\n\t\tc0.6-8.9,0.6-17.8,0.9-26.8H625.4z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M754.3,983.7c2.1,5.2,4.4,10.3,6.8,15.4c3.3,6.7,6.6,13.5,9.9,20.2c5.4,11.2,10.8,22.4,16.2,33.7h-20.8\n\t\tc-2.9-8.6-3.9-12-11.4-26.3h-33.6c-3.4,4.9-6.9,9.8-10.2,14.8c-2.4,3.7-4.6,7.6-6.8,11.5h-19.7l45.9-69.3L754.3,983.7L754.3,983.7z\n\t\t M727.2,1015.9h23.5l-9.9-21.4L727.2,1015.9z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M840.4,984c5.5,0.4,10.6,0.9,15.1,3.7c2.7,1.6,7.6,6.2,7.6,13.8c0,1-0.1,3.2-1,5.7\n\t\tc-0.9,2.6-3.6,8.8-11.6,12.7c-2.9,1.4-6.8,2.6-10,3.4l18.7,29.7H838c-2-4.2-4-8.2-6.4-12.2c-2.3-4.1-4.7-8.1-7.2-12\n\t\tc-3-4.9-5.9-9.7-8.8-14.4c2.9,0.2,5.7,0.4,8.6,0.4c2.3,0,12.2-0.1,17.1-5.5c2.3-2.6,2.5-5.2,2.5-6.4c0-1.1-0.3-4.2-3.3-6\n\t\tc-1.9-1.2-3.5-1.6-8.5-1.8l-18.8,0.1c-1.1,13.5-2.1,27.1-2.6,40.6c-0.3,5.8-0.4,11.5-0.5,17.3h-19.3c0.9-7.4,1.5-14.8,2-22.3\n\t\tc0.4-5.7,0.6-11.5,0.9-17.3c0.4-6.2,0.7-12.2,0.9-18.3c0.1-3.7,0.1-7.3,0.1-11L840.4,984L840.4,984z",
                            },
                          }),
                          _c("path", {
                            staticClass: "st693",
                            attrs: {
                              d: "M887.1,983.7c5.5-0.1,11-0.3,16.4-0.3c5.6,0,11.2,0.2,16.7,0.4c8,1,13.4,1.9,19.3,6.4c3.9,2.9,6,6.4,6.8,7.7\n\t\tc3.9,6.9,3.7,13.3,3.5,21c-0.7,6.8-1.1,8.3-3.6,14.8c-0.4,0.8-0.7,1.6-1.3,2.4c-1.5,2.7-5.2,9-14.2,13c-3.7,1.6-6.8,2.4-14.9,3.3\n\t\tc-6.8,0.3-13.4,0.6-20.3,0.6c-3.7,0-7.6-0.1-11.4-0.1c-5.7,0-11.5,0-17.2,0.1c0.6-5.9,1.4-11.9,1.7-17.8c0.3-4.9,0.4-9.7,0.7-14.5\n\t\tc0.4-6.8,0.9-13.8,1.1-20.6c0.3-5.4,0.3-10.9,0.4-16.3h16.2L887.1,983.7L887.1,983.7z M885.9,1041.2c5.7,0,11.6,0.1,17.2-0.2\n\t\tl6.4-0.3c0.4-0.1,4-0.5,6.3-1.2c2.1-0.6,6.8-2.1,10.2-6.3c3.9-4.7,6-12.2,6-17.8c0-2.9-0.4-14.8-13.9-18.5c-3.1-0.9-5.7-1-9-1.2\n\t\th-20.5L885.9,1041.2z",
                            },
                          }),
                        ]),
                      ]
                    ),
                  ]),
                ]
              },
            },
          ]),
        },
        [_c("span", [_vm._v("Price Guard")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }